<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'coupon_list'}" class="float-left mr-1 main-link">{{$t('coupon.coupon')}}</router-link> / {{$t('coupon.detail')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('coupon.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">

          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.basic_information') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                  <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                  <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row"  v-show="getCouponConfigByType('show', 'code')">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.code')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input class="form-control" v-model="item.code"
                        v-bind:placeholder="$t('coupon.code')" :state="!$v.item.code.$invalid"
                        :change="updateCrmURL()"
                        aria-describedby="code-feedback" :disabled="getCouponConfigByType('disable', 'code')"/>
                      <b-form-invalid-feedback :id="'coupon-code-feedback'">
                        <p class="help is-danger" v-if="!$v.item.code.required">{{ $t('message.required_filed') }}</p>
                        <p class="help is-danger" v-else-if="!$v.item.code.maxLength">{{ $t('coupon.coupon') }} {{ $t('coupon.coupon_max') }} {{$v.item.code.$params.maxLength.max}} {{ $t('coupon_character') }}.</p>
                        <p class="help is-danger" v-else-if="!$v.item.code.codeRegex">{{ $t(isJapanMarket() ? 'jp_code_regex_validation' : 'code_regex_validation') }}.</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.sku')}}</legend>
                    <div class="col-sm-10">
                      <multiselect v-model="item.skuData"
                        :placeholder="$t('coupon.sku')"
                        label="text" track-by="value"
                        @input="updateReceiptName"
                        @search-change="onChangeSkuSearch"
                        :value="item.skuData"
                        :clear-on-select="false"
                        :preserve-search="true"
                        :options="customCouponMasterData"
                        v-bind:selectLabel="$t('menu.select_label')"
                        v-bind:deselectLabel="$t('menu.select_remove')"
                        v-bind:selectedLabel="$t('menu.selected')">
                      </multiselect>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-input
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :name="`name[${lang}]`" />
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.marketing_name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-input
                        v-model="item.marketing_name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :change="updateCrmURL()"
                        :name="`marketing_name[${lang}]`" />
                    </div>
                  </div>

                  <div class="form-group row" v-show="getCouponConfigByType('show', 'receipt_name')">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.receipt_name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-input
                        v-model="item.receipt_name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :state="!$v.item.receipt_name.$invalid"
                        :name="`receipt_name[${lang}]`" :disabled="getCouponConfigByType('disable', 'receipt_name')"/>
                      <b-form-invalid-feedback :id="'coupon-code-feedback'">
                        <p class="help is-danger" v-if="!$v.item.receipt_name.required">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <div class="form-group row margin-top20">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.description') }}
                    </legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-textarea class="form-control" v-model="item.content[lang]"
                      :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_'+lang)">
                      </b-form-textarea>
                    </div>
                  </div>

                  <div class="form-group row" v-show="getCouponConfigByType('show', 'sequence')">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.sequence')}}</legend>
                    <div class="col-sm-5" >
                      <b-form-input type="number"
                        min="1"
                        class="form-control"
                        v-model="item.sequence"
                        v-bind:placeholder="$t('coupon.sequence')" :state="!$v.item.sequence.$invalid"
                        :disabled="getCouponConfigByType('disable', 'sequence')"
                        aria-describedby="sequence-feedback"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.number_of_coupon')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input type="number"
                        class="form-control"
                        v-model="item.number_of_coupon"
                        v-bind:placeholder="$t('coupon.number_of_coupon')" :state="!$v.item.number_of_coupon.$invalid"
                        aria-describedby="number_of_coupon-feedback"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="coupon-image col-sm-6" v-for="(urlValue, keyName) in imageData"  :key="`${keyName}-${imageDataKey}`">
                      <legend class="col-sm-4 col-form-label">
                        {{ $t('coupon.image_'+keyName) }}
                        <b-tooltip :target="'image-' + keyName" placement="top">
                          <div class="text-left" v-html="getImageHelpInfo('coupon', keyName)"></div>
                        </b-tooltip>
                      </legend>
                      <div class="col-sm-8">
                        <b-form-file :id="keyName" @change="previewImage" accept="image/*"
                        :placeholder="$t('message.choose_a_file')"></b-form-file>

                      <div class="img-min-height">
                        <ImagePreview
                        :url="urlValue" :keyUrl="keyName" @onDeleteImage="handleDeleteImage" />
                      </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <b-col cols="12">
                      <b-row>
                      <b-col cols="2" class="col-sm-2 col-form-label">
                        {{ $t('coupon.properties') }}
                      </b-col>
                      <b-col cols="10">
                        <b-row>
                          <b-col cols="3">
                            <b-form-group v-show="getCouponConfigByType('show', 'is_show')" v-bind:label="$t('coupon.is_show')" :label-cols="5" label-align-sm="right">
                              <c-switch-custom type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                        :pill="true" v-model="item.is_show" :value="1" :uncheckedValue="0" v-show="getCouponConfigByType('show', 'is_show')" :disabled="getCouponConfigByType('disable', 'is_show')"/>
                            </b-form-group>
                          </b-col>
                          <b-col cols="3">
                            <b-form-group v-bind:label="$t('coupon.accept_online_order')" :label-cols="5" label-align-sm="right">
                              <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                        :pill="true" v-model="item.is_accept_online_order" :value="1" :uncheckedValue="0"/>
                            </b-form-group>
                          </b-col>
                          <b-col cols="3" v-if="isSccJointly || !item.is_senior_citizen">
                            <b-form-group v-bind:label="$t('coupon.multiple_use')" :label-cols="5" label-align-sm="right">
                              <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                        :pill="true" v-model="item.multiple_use" :value="1" :uncheckedValue="0"/>
                            </b-form-group>
                          </b-col>
                          <b-col cols="3">
                            <b-form-group v-bind:label="$t('coupon.auto_apply')" :label-cols="5" label-align-sm="right">
                              <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                        :pill="true" v-model="item.auto_apply" :value="1" :uncheckedValue="0" @change="handleChangeAutoApply" />
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    </b-col>
                    <b-col cols="12">
                      <b-row>
                          <b-col cols="2">
                          </b-col>
                          <b-col cols="10">
                            <b-row>
                              <b-col cols="3">
                                <b-form-group v-bind:label="$t('coupon.cover_all_menu')" :label-cols="5" label-align-sm="right">
                                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true" v-model="item.cover_all_menu" :value="1" :uncheckedValue="0"/>
                                </b-form-group>
                              </b-col>
                              <b-col cols="3">
                                <b-form-group v-bind:label="$t('coupon.private_use')" :label-cols="5" label-align-sm="right">
                                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true" v-model="item.private_use" :value="1" :uncheckedValue="0"/>
                                </b-form-group>
                              </b-col>
                              <b-col cols="3">
                                <b-form-group v-show="getCouponConfigByType('show', 'can_use_direct')" v-bind:label="$t('coupon.can_use_direct')" :label-cols="5" label-align-sm="right">
                                  <c-switch v-show="getCouponConfigByType('show', 'can_use_direct')" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true" v-model="item.can_use_direct" :value="1" :uncheckedValue="0"/>
                                </b-form-group>
                              </b-col>
                              <b-col v-if="isSupportClient()" cols="3">
                                <b-form-group v-bind:label="$t('coupon.auto_assign')" :label-cols="5" label-align-sm="right">
                                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true" v-model="item.auto_assign" :value="1" :uncheckedValue="0"/>
                                </b-form-group>
                              </b-col>
                               <b-col v-if="isPhilippines()" cols="3">
                                <b-form-group v-bind:label="$t('coupon.phi_senior_citizen')" :label-cols="5" label-align-sm="right" label-class="senior-citizen">
                                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true" v-model="item.is_senior_citizen" :value="1" :uncheckedValue="0"/>
                                </b-form-group>
                              </b-col>
                              <b-col cols="3">
                                <b-form-group v-show="getCouponConfigByType('show', 'by_pass_min_cart')" v-bind:label="$t('coupon.by_pass_min_cart')" :label-cols="5" label-align-sm="right">
                                  <c-switch v-show="getCouponConfigByType('show', 'by_pass_min_cart')" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true" v-model="item.by_pass_min_cart" :value="1" :uncheckedValue="0"/>
                                </b-form-group>
                              </b-col>
                              <b-col v-if="getCouponConfigByType('show', 'single_use_coupon_login')" cols="3">
                                <b-form-group v-bind:label="$t('coupon.single_use_coupon_login')" :label-cols="5" label-align-sm="right">
                                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                            :pill="true" v-model="item.single_use_coupon_login" :value="1" :uncheckedValue="0"/>
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                    </b-col>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Basic information -->

          <!-- Time settings -->
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.time_settings') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateTimeSettingStatus"  v-b-toggle.time_settings_content>
                <i class="fa fa-sort-down" v-if="timeSettingStatus"></i>
                <i class="fa fa-sort-up" v-if="!timeSettingStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="timeSettingStatus" id="time_settings_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row" v-if="isSupportClient() && item.auto_assign">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.valid_for')}}</legend>
                    <div class="col-sm-3">
                      <b-form-input class="form-control valid-for-combobox" v-model="validForCoupon" @keyup="formatValidFor"/>
                      <p class="float-left col-form-label">{{$t('coupon.days_after_account_creation')}}</p>
                    </div>
                  </div>

                  <div :class="(!$v.item.active_start_date.validDate || !$v.item.active_end_date.validDate ? 'mb-0' : '') + 'form-group row '">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.active_period')}}</legend>

                    <!--<masked-input type="text" name="date" class="form-control col-sm-5 float-left" v-model="item.active_start_date" :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true" :keepCharPositions="true">
                    </masked-input>
                    <masked-input type="text" name="date" class="form-control col-sm-5 float-left" v-model="item.active_end_date" :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true" :keepCharPositions="true">
                    </masked-input>-->

                    <div class="col-sm-3">
                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.active_start_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.active_start_date.$invalid ? 'error' : ''"
                        :change="(e) => item.active_start_date = e"
                      />

                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.active_end_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.active_end_date.$invalid ? 'error' : ''"
                        :change="(e) => item.active_end_date = e"
                      />
                    </div>
                  </div>
                  <div class="form-group row" v-if="!$v.item.active_start_date.validDate || !$v.item.active_end_date.validDate">
                    <legend class="col-sm-2"></legend>
                    <b-form-invalid-feedback class="col-sm-10 d-block" :id="'active-period-feedback'">
                      <p class="help is-danger mb-0">{{$t('invalid_period_time_range')}}</p>
                    </b-form-invalid-feedback>
                  </div>

                  <div :class="(!$v.item.apply_start_date.validDate || !$v.item.apply_end_date.validDate ? 'mb-0' : '') + 'form-group row '">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.applicable_period')}}</legend>
                    <div class="col-sm-3">
                      <!--<masked-input type="text" name="date" class="form-control col-sm-5 float-left" v-model="item.apply_start_date" :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true" :keepCharPositions="true">
                      </masked-input>
                      <masked-input type="text" name="date" class="form-control col-sm-5 float-left" v-model="item.apply_end_date" :mask="[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]" :guide="true" placeholderChar="_" :showMask="true" :keepCharPositions="true">
                      </masked-input>-->
                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.apply_start_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.apply_start_date.$invalid ? 'error' : ''"
                        :change="(e) => item.apply_start_date = e"
                      />

                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.apply_end_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :errorClass="$v.item.apply_end_date.$invalid ? 'error' : ''"
                        :change="(e) => item.apply_end_date = e"
                      />

                    </div>
                  </div>
                  <div class="form-group row" v-if="!$v.item.apply_start_date.validDate || !$v.item.apply_end_date.validDate">
                    <legend class="col-sm-2"></legend>
                    <b-form-invalid-feedback class="col-sm-10 d-block" :id="'apply-period-feedback'">
                      <p class="help is-danger mb-0">{{$t('invalid_period_time_range')}}</p>
                    </b-form-invalid-feedback>
                  </div>

                  <!-- <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.crm_url')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input
                        class="form-control"
                        v-model="item.crm_url"
                        :readonly="true"
                        v-bind:placeholder="$t('coupon.crm_url')"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.applicable_active_date_for_user')}}</legend>
                    <div class="col-sm-2" style="display: inline-flex;">
                      <b-form-input type="number"
                        class="form-control"
                        v-model="item.applicable_active_date_for_user"/>
                        <span style="margin-left: 10px; margin-top: 5px">{{$t('coupon.day_s')}}</span>
                    </div>
                  </div> -->

                  <!-- time -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.day_of_week')}}</legend>
                    <div class="col-sm-10">
                      <div class="gray-background">
                        <div class="business-hours">
                          <b-form-checkbox v-for="(time,key) in item.timeHours" :key="key+0" :value="time.proper_date" unchecked-value="" v-if="checkDateRange(time.date)" v-model="item.timeHours[7].value" plain>{{$t(time.date)}}</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div >

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.hut_day') }}
                    </legend>
                    <div class="col-sm-10" >
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                        :pill="true" v-model="item.hut_day" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.lunch_time') }}
                    </legend>
                    <div class="col-sm-10" >
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                        :pill="true" v-model="item.lunch_time" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.exception_date')}}</legend>
                    <div class="col-sm-10">
                      <a class="add-more" v-on:click="addSpecialDate()"><i class="fa fa-plus"></i>{{$t('coupon.add_more')}}</a>

                      <table class="table table-bordered table-hover">
                        <thead>
                        <tr>
                          <th class="hide">{{$t('coupon.exception_table_name')}}</th>
                          <th>{{$t('coupon.exception_start_date')}}</th>
                          <th>{{$t('coupon.exception_end_date')}}</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(date, index) in item.special_dates" :key="date.id">
                          <td class="hide">
                            <b-form-input class="form-control" v-model="item.special_dates[index].name">
                            </b-form-input>
                          </td>
                          <td>
<!--
                            <date-picker :language="$session.get('lang')" class="not_apply_date" v-model="item.special_dates[index].start_date" lang="en" type="datetime" format="DD-MM-YYYY [at] HH:mm:ss"></date-picker>
-->
                            <date-picker-input
                              className="form-control col-sm-5 float-left"
                              name="date"
                              type="datetime"
                              :value="item.special_dates[index].start_date"
                              :hasPicker="true"
                              formatInput="DD-MM-YYYY HH:mm:ss"
                              formatOutput="DD-MM-YYYY HH:mm:ss"
                              :change="(e) => item.special_dates[index].start_date = e"
                            />
                          </td>
                          <td>
<!--
                            <date-picker :language="$session.get('lang')" class="not_apply_date" v-model="item.special_dates[index].end_date" lang="en" type="datetime" format="DD-MM-YYYY [at] HH:mm:ss"></date-picker>
-->
                            <date-picker-input
                              className="form-control col-sm-5 float-left"
                              name="date"
                              type="datetime"
                              :value="item.special_dates[index].end_date"
                              :hasPicker="true"
                              formatInput="DD-MM-YYYY HH:mm:ss"
                              formatOutput="DD-MM-YYYY HH:mm:ss"
                              :change="(e) => item.special_dates[index].end_date = e"
                            />
                          </td>
                          <td class="center">
                            <b-button variant="danger" v-on:click="removeSpecialDate(index)"
                            size="sm"><i class="fa fa-trash-o"></i></b-button>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>

                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Time settings -->

          <!-- Application Result -->
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.application_result') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateApplicationResultStatus" v-b-toggle.application_result_content>
                  <i class="fa fa-sort-down" v-if="applicationResultStatus"></i>
                  <i class="fa fa-sort-up" v-if="!applicationResultStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="applicationResultStatus" id="application_result_content">
              <b-form class="row">
                <b-col cols="12">

                  <div class="gray-background">
                    <div class="form-group row">
                      <legend class="col-sm-2 col-form-label">{{$t('coupon.coupon_type')}}</legend>
                      <div class="col-sm-10" >
                        <b-form-select
                          v-model="item.coupon_type_id"
                          :options="coupontypies[$session.get('lang')]"
                          v-bind:placeholder="$t('coupon.select_coupon_type')"
                          :state="!$v.item.coupon_type_id.$invalid"
                          @change="updateCouponType"
                          :aria-describedby="'coupon-type-feedback'"/>
                          <b-form-invalid-feedback :id="'coupon-type-feedback'">
                            {{ $t('message.required_filed') }}
                          </b-form-invalid-feedback>
                      </div>
                    </div>
                  </div>

                  <div class="gray-light-background" v-if="item.coupon_type_id!=4">
                    <!-- discount item -->
                    <div class="form-group row" v-if="item.coupon_type_id==1">
                      <legend class="col-sm-2 col-form-label"></legend>
                      <div class="col-sm-10">
                        <b-form-invalid-feedback v-if="!validFreeItemCouponForm && isEmptyFreeItem(item)" class="d-block font-size-inherit" id="discount_menu_items-feedback">
                          <p class="help is-danger">{{ $t('required_one_item') }}</p>
                        </b-form-invalid-feedback>
                        <a class="add-more" v-on:click="addDiscountMenuItem()"><i class="fa fa-plus"></i>{{$t('coupon.add_more')}}</a>
                        <div v-for="(parent, index) in item.discount_menu_items" :key="parent.id">
                          <div class="gray-background margin-top20">
                            <div class="form-group row align-items-center">
                              <div class="col-sm-9">
                                <multiselect
                                     v-model="parent.parent_item_selected"
                                     :options="menusList"
                                     :multiple="false"
                                     group-values="items"
                                     group-label="group"
                                     :group-select="false"
                                     :class="invalidCrustNSizeItem(parent) ? 'is-invalid' : ''"
                                     v-bind:placeholder="$t('common.name')"
                                     track-by="text"
                                     label="text"
                                     @input="discountMenuItemChange(parent)"
                                     v-bind:selectLabel = "$t('menu.select_label')"
                                     v-bind:deselectLabel = "$t('menu.select_remove')"
                                     v-bind:selectedLabel = "$t('menu.selected')"
                                     >
                                </multiselect>
                              </div>

                              <div class="col-sm-3">
                                <b-button v-if="needToAddCrustNSize(parent)" variant="primary" class="border-radius-4px pl-3 pr-3" v-on:click="addDiscountMenuSizeCrust(parent)">
                                  <i data-v-575aaa9b="" class="fa fa-plus"></i>
                                  {{$t('coupon.size_crust')}}
                                </b-button>

                                <b-button style="margin: 3px 0 3px 10px;" variant="danger" v-on:click="removeDiscountMenuItem(index)" size="sm"><i class="fa fa-trash"></i></b-button>
                              </div>
                              <div class="col-sm-9" style="margin-left: 10px" v-if="invalidCrustNSizeItem(parent)">
                                <b-form-invalid-feedback class="d-block font-size-inherit" id="discount_menu_items-feedback">
                                  <p class="help is-danger mb-0">{{ $t('required_crust_size') }}</p>
                                </b-form-invalid-feedback>
                              </div>
                            </div>
                          </div>

                          <div v-for="(child, child_index) in parent.list_child" :key="child_index">
                            <div class="gray-light-background">

                              <div class="form-group row">
                                  <legend class="col-sm-1 col-form-label">{{$t('coupon.variant')}}</legend>
                                  <div class="col-sm-4" >
                                    <b-form-select
                                      @input="discountMenuSizeCrustChange(parent,child,$session.get('lang'))"
                                      v-model="child.list_variant_selected"
                                      :options="child.list_variant[$session.get('lang')]" />
                                  </div>
                                  <template v-if="isEmpty(child.list_variant_selected) || (!isEmpty(child.list_variant_selected) && !isEmpty(child.list_add_on[$session.get('lang')]))">
                                    <legend class="col-sm-1 col-form-label">{{$t('coupon.addon')}}</legend>
                                    <div class="col-sm-4" style="padding-right: 5px;">
                                      <b-form-select
                                        v-model="child.list_add_on_selected"
                                        :options="child.list_add_on[$session.get('lang')]"
                                        @input="validateFreeItemCoupon()" />
                                    </div>
                                  </template>
                                  <div class="col-sm-2 col-sm-2-custom">
                                    <b-button variant="danger" v-on:click="removeDiscountMenuSizeCrust(parent,child_index)" size="sm"><i class="fa fa-trash"></i></b-button>
                                  </div>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <!-- discount item -->

                    <!-- discount unit || discount percent -->
                    <div class="form-group row" v-if="item.coupon_type_id===2 || item.coupon_type_id===3">
                      <legend class="col-sm-2 col-form-label">
                        {{
                          item.coupon_type_id===2 ? $t('coupon.type_discount_unit') :
                          (item.coupon_type_id===3 ? $t('coupon.type_discount_percent') : $t('coupon.type_discount_unit'))
                        }}
                      </legend>
                      <div class="col-sm-10" >
                        <b-form-input type="number"
                          class="form-control"
                          v-model="item.discount_percent_unit"
                          :state="!$v.item.discount_percent_unit.$invalid"
                          aria-describedby="discount_percent_unit-feedback"/>
                      </div>
                    </div>

                    <div class="form-group row" v-if="checkCitizenCoupon()">
                      <legend class="col-sm-2 col-form-label">
                        {{
                          $t('coupon.sc_vat')
                        }}
                      </legend>
                      <div class="col-sm-10" >
                        <b-form-input type="number"
                          class="form-control"
                          v-model="item.sc_vat"
                          :state="!$v.item.sc_vat.$invalid"
                          aria-describedby="sc_vat-feedback"/>
                      </div>
                    </div>

                    <div class="form-group row" v-if="checkCitizenCoupon()">
                      <legend class="col-sm-2 col-form-label">
                        {{
                          $t('coupon.discount_limit')
                        }}
                      </legend>
                      <div class="col-sm-10" >
                        <b-form-input type="number"
                          class="form-control"
                          v-model="item.discount_limit"
                          :state="!$v.item.discount_limit.$invalid"
                          aria-describedby="discount_limit-feedback"/>
                      </div>
                    </div>

                    <div class="form-group row" v-if="!checkCitizenCoupon()">
                      <legend class="col-sm-2 col-form-label">
                        {{ $t('coupon.applicable_items') }}
                      </legend>
                      <div class="col-sm-10" >
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                          :pill="true" v-model="item.applicable_items" :value="1" :uncheckedValue="0" />
                      </div>
                    </div>
                    <!-- discount unit || discount percent -->

                    <!-- Require at least one category or one menu -->
                    <div class="form-group row" v-if="invalidRequireItemDiscount(item)">
                      <legend class="col-sm-2 col-form-label"></legend>
                      <b-form-invalid-feedback class="col-sm-10 d-block font-size-inherit" id="circle_menu_items-feedback">
                        <p class="help is-danger mb-0">{{ $t('required_one_cat_or_one_item') }}</p>
                      </b-form-invalid-feedback>
                    </div>

                    <!-- Limit number of discount -->
                    <div class="form-group row" v-if="(item.coupon_type_id==2 || item.coupon_type_id==3) && item.applicable_items">
                      <legend class="col-sm-2 col-form-label"></legend>
                      <div class="col-sm-10">
                        <div class="d-flex">
                          <legend class="col-sm-2 col-form-label px-0">{{$t('coupon.limit_number_of_discount')}}</legend>
                          <div class="col-sm-10 px-0">
                            <b-form-input type="number"
                              class="form-control"
                              v-model="item.max_discount_quantity"
                              :state="!$v.item.max_discount_quantity.$invalid"
                              aria-describedby="max_discount_quantity-feedback"/>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- discount unit -->
                    <div class="form-group row" v-if="item.coupon_type_id==2 && item.applicable_items==1">
                      <legend class="col-sm-2 col-form-label"></legend>
                      <custom-add-more-menu-item
                        v-model="item.discount_unit_categories"
                        :categoryList="categoryList"
                        :menusList="menusList"
                        :menus="menus"
                        :languages="$store.getters.languages"
                        :items="item.discount_unit_items"
                        :displayCategoryLabel="true"
                        :displayMenuLabel="true"
                        @input="changeCategories"
                        @change="changeItems"
                        :invalidCrustNSizeItem="invalidCrustNSizeItem"
                        :needToAddCrustNSize="needToAddCrustNSize"
                        />
                    </div>
                    <!-- discount unit -->

                    <!-- discount percent -->
                    <div class="form-group row" v-if="item.coupon_type_id==3 && item.applicable_items==1">
                      <legend class="col-sm-2 col-form-label"></legend>
                      <custom-add-more-menu-item
                        v-model="item.discount_percent_categories"
                        :categoryList="categoryList"
                        :menusList="menusList"
                        :menus="menus"
                        :languages="$store.getters.languages"
                        :items="item.discount_percent_items"
                        :displayCategoryLabel="true"
                        :displayMenuLabel="true"
                        @input="changeCategories"
                        @change="changeItems"
                        :invalidCrustNSizeItem="invalidCrustNSizeItem"
                        :needToAddCrustNSize="needToAddCrustNSize"
                        />
                    </div>
                    <!-- discount percent -->

                    <!-- circle discount -->
                    <div class="form-group row" v-if="item.coupon_type_id==5">
                      <legend class="col-sm-1 col-form-label">
                        {{ $t('coupon.get') }}
                      </legend>
                      <div class="col-sm-7" style="padding-left: 5px; display: inline-flex;">
                        <div class="col-sm-2" style="min-width: 20%">
                          <b-form-select
                          v-model="item.circle_discount_type"
                          :options="circle_discount_type_data[$session.get('lang')]"
                          class="sl-discount-unit"
                          @change="loadCircleDiscountForm"
                          />
                        </div>
                        <div class="col-sm-10" style="display: inline-flex;">
                          <b-form-input type="number"
                            v-if="item.circle_discount_type=='unit'"
                            class="form-control ipt-discount-unit"
                            v-model="item.discount_percent_unit"
                            v-bind:placeholder="$t('coupon.spend')" :state="!$v.item.discount_percent_unit.$invalid"
                            aria-describedby="discount_percent_unit-feedback"/>

                          <!-- load item -->
                          <multiselect
                            v-if="item.circle_discount_type=='free_item'"
                             v-model="item.circle_menu_item_selected"
                             :options="menusList"
                             :multiple="false"
                             group-values="items"
                             group-label="group"
                             :group-select="false"
                             :class="invalidCrustNSizeItem(item.circle_menu_item_selected) ? 'is-invalid' : ''"
                             v-bind:placeholder="$t('common.name')"
                             track-by="text"
                             label="text"
                             @input="menuItemChange()"
                            v-bind:selectLabel = "$t('menu.select_label')"
                            v-bind:deselectLabel = "$t('menu.select_remove')"
                            v-bind:selectedLabel = "$t('menu.selected')"
                             >
                          </multiselect>
                          <b-button style="margin-left: 10px" v-if="needToAddCrustNSize(item) && item.circle_menu_item_selected.list_child.length <= 0" variant="primary" class="border-radius-4px pl-3 pr-3" v-on:click="addSizeCrust(item.circle_menu_item_selected)">
                            <i data-v-575aaa9b="" class="fa fa-plus"></i>
                            {{$t('coupon.size_crust')}}
                          </b-button>

                        </div>
                      </div>
                      <legend class="col-sm-2 col-form-label">
                        {{ $t('coupon.spend') }}
                      </legend>
                      <div class="col-sm-2" >
                        <b-form-input type="number"
                          class="form-control"
                          v-model="item.discount_each_amount"
                          v-bind:placeholder="$t('coupon.get')" :state="!$v.item.discount_each_amount.$invalid"
                          aria-describedby="discount_each_amount-feedback"/>
                      </div>
                    </div>
                    <div class="form-group row" v-if="item.coupon_type_id==5 && !validFreeItemCouponForm">
                      <div class="col-sm-1"></div>
                      <div class="col-sm-7" style="padding-left: 5px; display: inline-flex;">
                        <b-form-invalid-feedback class="col-sm-12 d-block font-size-inherit" id="circle_menu_items-feedback" v-if="invalidCrustNSizeItem(item.circle_menu_item_selected)">
                          <p class="help is-danger mb-0">{{ $t('required_crust_size') }}</p>
                        </b-form-invalid-feedback>
                        <b-form-invalid-feedback class="col-sm-12 d-block font-size-inherit" id="circle_menu_items-feedback" v-else>
                          <p class="help is-danger mb-0">{{ $t('required_one_item') }}</p>
                        </b-form-invalid-feedback>
                      </div>
                    </div>
                    <!-- circle discount -->
                    <template v-if="!isEmpty(item.circle_menu_item_selected)">
                      <div class="form-group row" v-for="(child, child_index) in item.circle_menu_item_selected.list_child" :key="child_index">
                        <legend class="col-sm-1 col-form-label">{{$t('coupon.variant')}}</legend>
                        <div class="col-sm-4" >
                          <b-form-select
                            @input="sizeCrustChange(item.circle_menu_item_selected,child,$session.get('lang'))"
                            v-model="child.list_variant_selected"
                            :class="'size-circle'"
                            :options="child.list_variant[$session.get('lang')]" />
                        </div>
                        <template v-if="isEmpty(child.list_variant_selected) || (!isEmpty(child.list_variant_selected) && !isEmpty(child.list_add_on[$session.get('lang')]))">
                          <legend class="col-sm-1 col-form-label">{{$t('coupon.addon')}}</legend>
                          <div class="col-sm-4" style="padding-right: 5px;">
                            <b-form-select
                              v-model="child.list_add_on_selected"
                              @input="validateFreeItemCoupon()"
                              :options="child.list_add_on[$session.get('lang')]" />
                          </div>
                        </template>
                        <div class="col-sm-2 col-sm-2-custom">
                          <b-button variant="danger" v-on:click="removeSizeCrust(item.circle_menu_item_selected,child_index)" size="sm"><i class="fa fa-trash"></i></b-button>
                        </div>
                      </div>
                    </template>

                    <!-- Free Toppings -->
                    <div class="form-group row" v-if="item.coupon_type_id==6">
                      <legend class="col-sm-2 col-form-label">
                        {{ $t('coupon.toppings') }}
                      </legend>
                      <div class="col-sm-10">
                        <multiselect v-model="item.toppings"
                          v-bind:placeholder="$t('coupon.toppings')"
                          label="text" track-by="value"
                          :multiple="true"
                          :options="customToppingsData"
                          :taggable="true"
                                     v-bind:selectLabel = "$t('menu.select_label')"
                                     v-bind:deselectLabel = "$t('menu.select_remove')"
                                     v-bind:selectedLabel = "$t('menu.selected')">
                        </multiselect>
                      </div>
                    </div>
                    <!-- Free Toppings -->

                  </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Application Result -->

          <!-- Condition -->
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.applicable_condition') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateMenuRequiredStatus"  v-b-toggle.condition_content>
                <i class="fa fa-sort-down" v-if="menuRequiredStatus"></i>
                <i class="fa fa-sort-up" v-if="!menuRequiredStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="menuRequiredStatus" id="condition_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row" v-show="getCouponConfigByType('show', 'ala_carte_min_cart')">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.ala_carte_min_cart') }}
                    </legend>
                    <div class="col-sm-10">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                        :pill="true" v-model="item.ala_carte_min_cart" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.min_card') }}
                    </legend>
                    <div class="col-sm-10">
                      <b-form-input type="number"
                      class="form-control" v-model="item.min_card"
                      :state="!$v.item.min_card.$invalid"
                      :aria-describedby="'number-min-card-state-feedback'">
                      <b-form-invalid-feedback :id="'number-min-card-state-feedback'">
                        {{ $t('coupon.cart_invalid') }}
                        </b-form-invalid-feedback>
                      </b-form-input>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.order_type') }}
                    </legend>
                    <div class="col-sm-10">
                      <b-form-select
                          v-model="item.order_type"
                          :options="coupon_order_types[$session.get('lang')]" />
                    </div>
                  </div>

                  <div class="form-group row" v-show="getCouponConfigByType('show', 'sale_channel')">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.sale_channel') }}
                    </legend>
                    <div class="col-sm-10">
                      <multiselect v-model="item.sale_channel"
                         v-bind:placeholder="$t('coupon.sale_channel')"
                         label="text" track-by="value"
                         :multiple="true"
                         :options="sale_channels[$session.get('lang')] || []"
                         :taggable="true"
                         v-bind:selectLabel = "$t('coupon.select_label')"
                         v-bind:deselectLabel = "$t('coupon.select_remove')"
                         v-bind:selectedLabel = "$t('coupon.selected')">
                      </multiselect>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.future_advance_order_only') }}
                    </legend>
                    <div class="col-sm-10">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                        :pill="true" v-model="item.future_advance_order_only" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.check_is_member')}}</legend>
                    <div class="col-sm-10">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                        :pill="true" v-model="item.check_is_member" :value="1" :uncheckedValue="0"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.payment_methods')}}</legend>
                    <div class="col-sm-10">
                      <div class="gray-light-background payment-methods">
                        <div class="form-group row" v-for="(payment_method, k) in payment_methods">
                          <div class="col-sm-10" style="display: inline-flex;">
                            <b-form-checkbox :disabled="item.auto_apply == 1" :value="payment_method.method" unchecked-value="" v-model="payment_method.selected" plain>{{payment_method.display_name}} <span v-if="payment_method.description"> - {{$t('coupon.source')}}: {{payment_method.description}}</span></b-form-checkbox>
                          </div>
                          <div class="col-sm-2">
                            <img :src="payment_method.image" width="auto" height="35" style="float: right; margin-right: 20px" />
                          </div>
                          <hr v-if="k < payment_methods.length-1" style="width: 100%; border: 1px solid #DDE2E8; margin-top: 10px; margin-bottom: 0;">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.applicable_store') }}
                    </legend>
                    <div class="col-sm-10 applicable-store ">
                      <multiselect
                          v-model="item.outlet_group_uuid"
                          track-by="value"
                          label="text"
                          :multiple="true"
                          :options="outletGroupsList"
                          :placeholder="$t('coupon.select_outlet_group')"
                          v-bind:selectLabel = "$t('coupon.select_label')"
                          v-bind:deselectLabel = "$t('coupon.select_remove')"
                          v-bind:selectedLabel = "$t('coupon.selected')"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">

                    </legend>
                    <div class="col-sm-10 applicable-store ">
                      <div style="padding-left: 5px;">
                        <label class="file-select">
                          <div class="select-button">
                            <span>{{$t('common.upload')}}</span>
                          </div>
                          <input type="file" accept=".csv" @change="uploadStores"/>
                        </label>
                      </div>
                      <div v-if="item.validate_store_name!=''" style="margin-left: 5px; display: inline-table;" >
                        <a :href="item.validate_store_url" target="_blank" style="word-break: break-all;" >{{item.validate_store_name}}</a>
                        <b-button class="delete-csv" v-if="item.validate_store_name" variant="danger" v-on:click="removeStoreUrl(item.validate_store_name)" size="sm"><i class="fa fa-trash"></i></b-button>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                    </legend>
                    <div class="col-sm-10">
                      {{ $t('coupon.example_text_1') }}
                      <a :href="store_url">{{ $t('coupon.example_text_2') }}</a>
                      {{ $t('coupon.example_text_3') }}
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.exclude_outlet') }}
                    </legend>
                    <div class="col-sm-10">
                      <multiselect v-model="item.exclude_outlet_list"
                        v-bind:placeholder="$t('coupon.exclude_outlet')"
                        label="text" track-by="value"
                        :multiple="true"
                        :options="outletsList"
                        :taggable="true"
                                   v-bind:selectLabel = "$t('menu.select_label')"
                                   v-bind:deselectLabel = "$t('menu.select_remove')"
                                   v-bind:selectedLabel = "$t('menu.selected')">
                      </multiselect>
                    </div>
                  </div>

                  <div class="form-group row" v-if="item.private_use">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.applicable_user') }}
                    </legend>
                     <div class="col-sm-3" style="max-width: 19%">
                      <label class="file-select">
                        <div class="select-button">
                          <span>{{$t('common.upload')}}</span>
                        </div>
                        <input type="file" accept=".csv" @change="uploadUsers"/>
                      </label>
                      <div>
                        <a :href="item.single_user_url" target="_blank">{{item.single_user_name}}</a>
                        <b-button class="delete-csv" v-if="item.single_user_url" variant="danger" v-on:click="removeUserUrl(item.single_user_name)" size="sm"><i class="fa fa-trash"></i></b-button>
                      </div>
                    </div>
                    <div class="col-sm-7" style="margin-top: 5px">
                      <p v-for="user_url in item.validate_user_url" :key="user_url" ><a :href="user_url" target="_blank">{{ user_url }}</a></p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                    </legend>
                    <div class="col-sm-10">
                      {{ $t('coupon.example_text_1') }}
                      <a :href="user_url">{{ $t('coupon.example_text_2') }}</a>
                      {{ $t('coupon.example_text_3') }}
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.purchase_required') }}
                    </legend>
                    <div class="col-sm-10">
                      <b-form-select
                      v-model="item.purchase_required"
                      :options="purchase_required_data[$session.get('lang')]"
                      @change="loadRequiredForm"
                      />
                    </div>
                  </div>

                  <div class="form-group row" v-if="item.purchase_required != 'all'">
                    <legend class="col-sm-2 col-form-label">
                    </legend>
                    <custom-add-more-menu-item
                      v-model="item.condition_categories"
                      :categoryList="categoryList"
                      :menusList="menusList"
                      :menus="menus"
                      :languages="languages"
                      :items="item.require_menu_items"
                      :purchaseRequired="item.purchase_required"
                      :firstLayerData="customFirstLayerData"
                      :secondLayerData="customSecondLayerData"
                      :firstSelected="item.first_selected"
                      :secondSelected="item.second_selected"
                      :displayCategory="item.purchase_required=='category'?true:false"
                      :minDiscountQuantity="item.min_discount_quantity"
                      :invalidCrustNSizeItem="invalidCrustNSizeItem"
                      :needToAddCrustNSize="needToAddCrustNSize"
                      @changeFirstSelected="changeFirstSelected"
                      @changeSecondSelected="changeSecondSelected"
                      @changeMinDiscountQuantity="changeMinDiscountQuantity"
                      @input="changeCategories"
                      @change="changeItems"
                    />
                  </div>

                  <!-- Exclude Item -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.exclude_items') }}
                    </legend>
                    <div class="col-sm-10">
                      <b-form-select
                      v-model="item.exclude_items.exclude"
                      :options="exclude_item_data[$session.get('lang')]"
                      @change="loadExcludeItemForm"
                      />
                    </div>
                  </div>

                  <div class="form-group row" v-if="item.exclude_items.exclude != 'all'">
                    <legend class="col-sm-2 col-form-label">
                    </legend>
                    <custom-add-more-menu-item
                      :isHideMinDiscountQuantity="true"
                      v-model="item.exclude_items.condition_categories"
                      :categoryList="categoryList"
                      :menusList="menusList"
                      :menus="menus"
                      :languages="languages"
                      :items="item.exclude_items.require_menu_items"
                      :purchaseRequired="item.exclude_items.exclude"
                      :firstLayerData="customFirstLayerData"
                      :secondLayerData="customSecondLayerData"
                      :firstSelected="item.exclude_items.first_selected"
                      :secondSelected="item.exclude_items.second_selected"
                      :displayCategory="item.exclude_items.exclude=='category'?true:false"
                      :invalidCrustNSizeItem="invalidCrustNSizeItem"
                      :needToAddCrustNSize="needToAddCrustNSize"
                      @changeFirstSelected="changeExclusionFirstSelected"
                      @changeSecondSelected="changeExclusionSecondSelected"
                      @input="changeCategories"
                      @change="changeItems"
                    />
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Condition -->

          <!-- Special Setting -->
          <!-- <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.special_setting') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateSpecialSettingStatus" v-b-toggle.special_setting_content>
                  <i class="fa fa-sort-down" v-if="specialSettingStatus"></i>
                  <i class="fa fa-sort-up" v-if="!specialSettingStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="specialSettingStatus" id="special_setting_content">
              <b-form class="row">
                <b-col cols="12">
                    <div class="form-group row margin-top20">
                      <legend class="col-sm-2 col-form-label">
                        {{ $t('coupon.max_number_of_user') }}
                      </legend>
                      <div class="col-sm-10" >
                        <b-form-input type="number"
                         class="form-control" v-model="item.max_coupon_of_user"
                         :aria-describedby="'max-coupon-of-user-state-feedback'">
                         <b-form-invalid-feedback :id="'max-coupon-of-user-state-feedback'">
                            {{ $t('message.required_filed') }}
                          </b-form-invalid-feedback>
                        </b-form-input>
                      </div>
                    </div>

                    <div class="form-group row">
                      <legend class="col-sm-2 col-form-label">
                        {{ $t('coupon.max_email_click_of_user') }}
                      </legend>
                      <div class="col-sm-10" >
                        <b-form-input type="number"
                         class="form-control" v-model="item.max_email_click_of_user"
                         :aria-describedby="'max-email-click-of-user-state-feedback'">
                         <b-form-invalid-feedback :id="'max-email-click-of-user-state-feedback'">
                            {{ $t('message.required_filed') }}
                          </b-form-invalid-feedback>
                        </b-form-input>
                      </div>
                    </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>  -->
          <!-- Special Setting -->

          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'coupon_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button :disabled="$v.item.$invalid || !validFreeItemCouponForm || !validApplicableItemsDiscount" variant="success" v-on:click="saveCoupon()">&nbsp; {{ $t('common.save')}}</b-button>
            </div>
            <div class="btn-save">
              <b-button v-if="isCanSyncCoupon" :disabled="$v.item.$invalid || !validFreeItemCouponForm || !validApplicableItemsDiscount" variant="success" v-b-modal.sync_coupon>&nbsp; {{ $t('coupon.sync_coupon')}}</b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
    <b-modal id="sync_coupon" :title="$t('coupon.sync_coupon')" size="lg" :ok-disabled="!isCanSync()" @ok="syncCoupon">
      <div>
        <div class="animated fadeIn">
          <b-row>
            <b-col cols="12">
              <b-card>
                <b-form class="row">
                  <b-col cols="12">
                    <b-form-group v-bind:label="$t('coupon.marketing_name')" :label-cols="3">
                      <c-switch type="icon" variant="success" v-bind="{ on: '\uf00c', off: '\uf00d' }"
                        :pill="true" v-model="sync_coupon.marketing_name" :value="1" :uncheckedValue="0"/>
                    </b-form-group>
                    <b-form-group v-bind:label="$t('coupon.description')" :label-cols="3">
                      <c-switch type="icon" variant="success" v-bind="{ on: '\uf00c', off: '\uf00d' }"
                        :pill="true" v-model="sync_coupon.description" :value="1" :uncheckedValue="0"/>
                    </b-form-group>
                    <b-form-group v-bind:label="$t('coupon.active_period')" :label-cols="3">
                      <c-switch type="icon" variant="success" v-bind="{ on: '\uf00c', off: '\uf00d' }"
                        :pill="true" v-model="sync_coupon.active_period" :value="1" :uncheckedValue="0"/>
                    </b-form-group>
                    <b-form-group v-bind:label="$t('coupon.applicable_period')" :label-cols="3">
                      <c-switch type="icon" variant="success" v-bind="{ on: '\uf00c', off: '\uf00d' }"
                        :pill="true" v-model="sync_coupon.applicable_period" :value="1" :uncheckedValue="0"/>
                    </b-form-group>
                  </b-col>
                </b-form>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required,requiredIf,maxLength,between } from 'vuelidate/lib/validators'
import cSwitch from '../../../components/Switch'
import cSwitchCustom from '../../../components/SwitchCustom'
import MaskedInput from 'vue-text-mask'
import Multiselect from 'vue-multiselect'
import CustomAddMoreMenuItem from '../../../components/Partials/CustomAddMoreMenuItem'
import DateRangePicker from 'vue2-daterange-picker'
import DatePicker from 'vue2-datepicker'
import DatePickerInput from '@/components/Partials/DatePickerInput'
import ImagePreview from '@/components/Partials/ImagePreview'

const VALIDATION_SUCCESS = 1
const VALIDATION_SEVERAL_FAILED = 2
const VALIDATION_ALL_FAILED = 3
let vm = null
const CSV_FILE_PATTERN = /^.+\.(csv)$/
const FILTER_NUMBER = /\D/g
const SYNC_COUPON_API = 'put.v1.product-coupon-be.sync-coupon.?'

export default {
  props: {
    id: {
      type: String,
      required: true,
      default: 'create'
    }
  },
  components: {
    cSwitch,
    cSwitchCustom,
    MaskedInput,
    Multiselect,
    CustomAddMoreMenuItem,
    DateRangePicker,
    DatePicker,
    DatePickerInput,
    ImagePreview
  },
  data: function () {
    return {
      coupon: this.$store.getters.config.gms.coupon,
      prefix_crm_url: this.$store.getters.config.main.base_site_url,
      itemLimit: 10000,
      payment_methods: [],
      original_payment_methods: [],
      coupon_order_types: {},
      sale_channels: {},
      purchase_required_data: {},
      exclude_item_data: {},
      circle_discount_type_data: {},
      dates: ['common.mon', 'common.tue', 'common.wed', 'common.thu', 'common.fri', 'common.sat', 'common.sun'],
      images: ['desktop', 'mobile'],
      coupontypies: [],
      menus:{},
      custom_menus:{},
      firstLayerData:{},
      customFirstLayerData:[],
      secondLayerData:{},
      customSecondLayerData:[],
      toppingsData:{},
      customToppingsData:[],
      couponMasterData:{},
      customCouponMasterData:[],
      menusList: [],
      outletGroups:{},
      outletGroupsList:[],
      categories:{},
      categoryList:[],
      outlets:{},
      outletsList:[],
      isLoadingMenu: false,
      isLoadingOutletGroup: false,
      isLoadingOutlet: false,
      isLoadingCoupon: false,
      isLoadingCouponMaster: false,
      isProcessing: false,
      coupon_menus: [],
      item: {
        coupon_id: 0,
        uuid: "",
        timeHours: [],
        min_card:0,
        special_dates:[],
        exclude_outlet_list: "",
        condition_categories: "",
        discount_unit_categories: "",
        discount_percent_categories: "",
        max_coupon_of_user:1,
        max_email_click_of_user:1,
        sale_channel: [{"value":"web","text":"Web"},{"value":"ios","text":"Ios"},{"value":"android","text":"Android"}],
        purchase_required:"all",
        circle_discount_type: "unit",
        discount_each_amount:1,
        discount_percent_unit:1,
        order_type:"all",
        outlet_group_uuid:"",
        sequence: 1,
        number_of_coupon:0,
        content:{},
        coupon_menus: [],
        name:{},
        marketing_name:{},
        receipt_name: {},
        code:"",
        multiple_use:0,
        active:1,
        is_show:0,
        toppings: [],
        require_menu_items: [],
        discount_menu_items: [],
        discount_unit_items: [],
        discount_percent_items: [],
        coupon_type_id:"",
        active_start_date:this.$moment().format('DD-MM-YYYY'),
        active_end_date:'31-12-9999',
        apply_start_date:this.$moment().format('DD-MM-YYYY'),
        apply_end_date:'31-12-9999',
        image: {},
        validate_user_name: [],
        validate_user_url: [],
        upload_user_url: "",
        single_user_url: "",
        validate_store_url: "",
        single_user_name: "",
        validate_store_name: "",
        check_is_member: 0,
        is_accept_online_order: 1,
        applicable_items: 0,
        payment_methods: [],
        cover_all_menu: -1,
        auto_apply: 0,
        can_use_direct: 1,
        auto_assign: 0,
        is_senior_citizen: 0,
        valid_for: 0,
        by_pass_min_cart: 0,
        future_advance_order_only: 0,
        sku: "",
        skuData: {},
        private_use: 0,
        hut_day: 0,
        lunch_time: 0,
        mon: 0,
        tue: 0,
        wed: 0,
        thu: 0,
        fri: 0,
        sat: 0,
        sun: 0,
        first_selected: [],
        second_selected: [],
        circle_menu_item_selected: "",
        crm_url: "",
        applicable_active_date_for_user: 0,
        max_discount_quantity: 1,
        min_discount_quantity: 0,
        customize: { sc_vat: 0, discount_limit: 0 },
        sc_vat: 0,
        discount_limit: 0,
        exclude_items: {
          exclude: "all",
          condition_categories: "",
          first_selected: [],
          second_selected: [],
          require_menu_items: [],
          coupon_menus: []
        },
        ala_carte_min_cart: 0,
        single_use_coupon_login: 0
      },
      basicInformationStatus: true,
      timeSettingStatus: true,
      menuRequiredStatus: true,
      specialSettingStatus: true,
      applicationResultStatus: true,
      imageData: {},
      imageDataKey: 0,
      languages: Object.keys(this.$i18n.messages),
      menu_items_status: true,
      require_menu_items_status: true,
      store_url: "",
      upload_store_url: "",
      user_url: "",
      validFreeItemCouponForm: true,
      validApplicableItemsDiscount: true,
      validForCoupon: "",
      isSCCJoinly: false,
      isCanSyncCoupon: false,
      sync_coupon: {
        marketing_name: false,
        description: false,
        active_period: false,
        applicable_period: false
      },
      userInfo: this.$auth.user(),
      isSyncCouponPermision: false
    }
  },
  mixins: [
    validationMixin
  ],
  computed: {
    rules() {
      return {
        code: {
          required,
          maxLength: maxLength(50),
          codeRegex(code) {
            return this.validateCouponRegex(code)
          }
        },
        coupon_type_id:{
          required
        },
        sequence: {
          required,
          between: between(0, 999999999)
        },
        number_of_coupon: {
          required,
          between: between(0, 999999999)
        },
        discount_percent_unit: this.item.coupon_type_id == this.couponTypes.DISCOUNT_UNIT
        || this.item.coupon_type_id == this.couponTypes.CIRCLE_DISCOUNT
            ? { required, between: between(1, 999999999) }
            :  this.item.coupon_type_id == this.couponTypes.DISCOUNT_PERCENT ? { required, between: between(0.01, 100) }: {},
        discount_each_amount: this.item.coupon_type_id==5
            ? { required, between: between(1, 999999999) }
            : {},
        min_card:{
          required,
          between: between(0, 999999999)
        },
        max_discount_quantity: {
          required: requiredIf(function (nestedModel) {
            return this.item.coupon_type_id==2 || this.item.coupon_type_id==3
          }),
          between: between(0, 999999999)
        },
        min_discount_quantity: {
          required: requiredIf(function (nestedModel) {
            return this.item.purchase_required==='category'
          }),
          between: between(0, 999999999)
        },
        receipt_name: {
          required: requiredIf(function (nestedModel) {
            return this.isJapanMarket()
          }),
        },
        active_start_date: {
          validDate(active_start_date) {
            return this.validateDatetimeRange(active_start_date, this.item.active_end_date)
          }
        },
        active_end_date: {
          validDate(active_end_date) {
            return this.validateDatetimeRange(this.item.active_start_date, active_end_date)
          }
        },
        apply_start_date: {
          validDate(apply_start_date) {
            return this.validateDatetimeRange(apply_start_date, this.item.apply_end_date)
          }
        },
        apply_end_date: {
          validDate(apply_end_date) {
            return this.validateDatetimeRange(this.item.apply_start_date, apply_end_date)
          }
        },
        sc_vat: {
          required: requiredIf(function (nestedModel) {
            return this.item.is_senior_citizen && this.item.coupon_type_id == this.couponTypes.DISCOUNT_PERCENT
          }),
          between: between(0, 100)
        },
        discount_limit: {
          required: requiredIf(function (nestedModel) {
            return this.item.is_senior_citizen && this.item.coupon_type_id == this.couponTypes.DISCOUNT_PERCENT
          }),
          between: between(0, 999999999)
        }
      }
    }
  },
  validations() {
    return {
      item: this.rules
    }
  },
  methods: {
    handleDeleteImage(imageKey) {
      vm.imageData[`${imageKey}`] = ''
      vm.item.image[`${imageKey}`] = ''
      vm.imageDataKey += 1
    },
    updateReceiptName () {
      if (vm.item.skuData) {
        vm.item.receipt_name = vm.item.skuData.receipt_name
      } else {
        vm.item.receipt_name = {}
      }
    },
    onChangeSkuSearch (query) {
      this._.debounce(() => {
        const skuObj = this._.find(vm.customCouponMasterData, { value: query.trim().toUpperCase()}, null) || null;
        if (skuObj) {
          vm.item.skuData = skuObj
        } else {
          const freeItem = { text: query, value: query.trim().toUpperCase() };
          vm.item.skuData = freeItem;
        }
      }, 300)();
    },
    checkShowByConfig (key) {
      if (this.coupon == null) {
        return true
      }
      let config = this._.find(this.coupon.basic_info, function (o) {
        return o.type === key
      })
      if (config == null) {
        return false
      }
      return config.show
    },
    checkDisableByConfig (key) {
      if (this.coupon == null) {
        return false
      }
      let config = this._.find(this.coupon.basic_info, {type: key})
      if (config == null) {
        return false
      }
      return config.disable
    },
    updateCrmURL () {
      // let name = vm.item.marketing_name[vm.$session.get('lang')] ? vm.item.marketing_name[vm.$session.get('lang')] : '';
      // vm.item.crm_url = vm.prefix_crm_url + '/crm/coupon/' + name + '/' + vm.item.code
    },
    loadCircleDiscountForm (value){
      if (value=='unit') {
        vm.item.circle_menu_item_selected = ""
      } else {
        vm.item.discount_percent_unit=1
      }
      vm.validateFreeItemCoupon();
    },
    menuItemChange(){
      if(!vm.isEmpty(vm.item.circle_menu_item_selected)) vm.item.circle_menu_item_selected.list_child=[];
      vm.validateFreeItemCoupon();
    },
    sizeCrustChange(parent, menuItem, lang){
      if(!parent ||!menuItem || !menuItem.list_variant) return
      menuItem.list_add_on[lang]=[]
      var addon = _.find(menuItem.list_variant[lang], function (obj)
      {
        return obj.value === menuItem.list_variant_selected;
      });
      if(!addon) return
      menuItem.list_add_on[lang]=addon.addons;
      vm.validateFreeItemCoupon();
      vm.$forceUpdate(parent.list_child)
    },
    addSizeCrust(parent)
    {
      if(!parent) return;
      parent.list_child.push({
        list_variant:this.getVariantByMenuId(parent),
        list_variant_selected:"",
        list_add_on: [],
        list_add_on_selected:"",
        deleted:0,
        id:0
      })

      vm.$forceUpdate(parent.list_child)
    },
    removeSizeCrust(parent,index) {
      parent.list_child.splice(index, 1)
      vm.validateFreeItemCoupon();
      vm.$forceUpdate(parent.list_child)
    },

    loadRequiredForm (value){
      vm.item.purchase_required = value
      vm.item.condition_categories = ""
      vm.item.first_selected = []
      vm.item.second_selected = []
      vm.item.require_menu_items = []
      vm.item.min_discount_quantity=0
    },
    checkDateRange (value){
      return this.dates.indexOf(value) > -1 ? true : false
    },
    updateCouponType () {
      vm.item.applicable_items=0
      vm.item.max_discount_quantity=1
      vm.item.circle_discount_type='unit'
      vm.item.circle_menu_item_selected = ""
      vm.validateFreeItemCoupon();
    },
    changeCategories () {
      vm.validateApplicableItemsDiscount();
    },
    changeItems () {
      vm.validateApplicableItemsDiscount();
    },
    changeFirstSelected (data) {
      vm.item.first_selected = data
    },
    changeSecondSelected (data) {
      vm.item.second_selected = data
    },
    changeMinDiscountQuantity (data) {
      vm.item.min_discount_quantity = data
    },
    updateBasicInformationStatus () {
      this.basicInformationStatus = this.basicInformationStatus?false:true
    },
    updateTimeSettingStatus () {
      this.timeSettingStatus = this.timeSettingStatus?false:true
    },
    updateMenuRequiredStatus () {
      this.menuRequiredStatus = this.menuRequiredStatus?false:true
    },
    updateApplicationResultStatus () {
      this.applicationResultStatus = this.applicationResultStatus?false:true
    },
    updateSpecialSettingStatus () {
      this.specialSettingStatus = this.specialSettingStatus?false:true
    },
    checkCodeUnique(code){
      // return true
        return vm.axios.coupon.checkCode(code)
    },
    loadExcludeItemForm (value){
      vm.item.exclude_items.exclude = value
      vm.item.exclude_items.condition_categories = ""
      vm.item.exclude_items.first_selected = []
      vm.item.exclude_items.second_selected = []
      vm.item.exclude_items.require_menu_items = []
      vm.item.exclude_items.coupon_menus = []
    },
    changeExclusionCategories () {
      vm.validateApplicableItemsDiscount();
    },
    changeExclusionItems () {
      vm.validateApplicableItemsDiscount();
    },
    changeExclusionFirstSelected (data) {
      vm.item.exclude_items.first_selected = data
    },
    changeExclusionSecondSelected (data) {
      vm.item.exclude_items.second_selected = data
    },
    initialImage(){
      let data = {}
      for (let i in vm.images) {
        data[vm.images[i]] = ""
      }
      vm.imageData = data
    },
    initMenuItem(category, combo, single, first, second, type, category_sku, combo_sku, single_sku) {
      return {
        id:0,
        category_uuid: category,
        combo_uuid: combo,
        single_uuid: single,
        first_layer_sku: first,
        second_layer_sku: second,
        type: type,
        category_sku: category_sku,
        combo_sku: combo_sku,
        single_sku: single_sku,
        coupon_id:""
      }
    },

    processSaveCouponMenu (menuItems, type) {
      // process menu items
      switch (type) {
        case "circle_discount":
            let parent = menuItems
            if (parent.list_child.length > 0) {
              for (let c in parent.list_child) {
                let child = parent.list_child[c]

                let menuItem = vm.initMenuItem(
                                "",
                                parent.is_combo ? parent.value : "",
                                !parent.is_combo ? parent.value : "",
                                child.list_variant_selected,
                                child.list_add_on_selected,
                                type,
                                "",
                                parent.is_combo ? parent.sku : "",
                                !parent.is_combo ? parent.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            } else {
              if (parent) {
                let menuItem = vm.initMenuItem(
                                "",
                                parent.is_combo ? parent.value : "",
                                !parent.is_combo ? parent.value : "",
                                "",
                                "",
                                type,
                                "",
                                parent.is_combo ? parent.sku : "",
                                !parent.is_combo ? parent.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            }
        break;

        case "free":
          for (let f in menuItems) {
            let parent = menuItems[f]
            if (parent.list_child.length > 0) {
              for (let c in parent.list_child) {
                let child = parent.list_child[c]

                let menuItem = vm.initMenuItem(
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                child.list_variant_selected,
                                child.list_add_on_selected,
                                type,
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            } else {
              if (parent.parent_item_selected) {
                let menuItem = vm.initMenuItem(
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                "",
                                "",
                                type,
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            }
          }
        break;

        case "unit":
          // check categories
          for (let c in vm.item.discount_unit_categories) {
            let category = vm.item.discount_unit_categories[c]
            let menuItem = vm.initMenuItem(
                                        category.value,
                                        "",
                                        "",
                                        "",
                                        "",
                                        'unit_category',
                                        category.sku,
                                        "",
                                        "")
            vm.item.coupon_menus.push(menuItem)
          }

          // check items
          for (let f in menuItems) {
            let parent = menuItems[f]
            if (parent.list_child.length > 0) {
              for (let c in parent.list_child) {
                let child = parent.list_child[c]

                let menuItem = vm.initMenuItem(
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                child.list_variant_selected,
                                child.list_add_on_selected,
                                'unit',
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            } else {
              if (parent.parent_item_selected) {
                let menuItem = vm.initMenuItem(
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                "",
                                "",
                                'unit',
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            }
          }
        break;

        case "percent":
          // check categories
          for (let c in vm.item.discount_percent_categories) {
            let category = vm.item.discount_percent_categories[c]
            let menuItem = vm.initMenuItem(
                                        category.value,
                                        "",
                                        "",
                                        "",
                                        "",
                                        'percent_category',
                                        category.sku,
                                        "",
                                        "")
            vm.item.coupon_menus.push(menuItem)
          }

          // check items
          for (let f in menuItems) {
            let parent = menuItems[f]
            if (parent.list_child.length > 0) {
              for (let c in parent.list_child) {
                let child = parent.list_child[c]

                let menuItem = vm.initMenuItem(
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                child.list_variant_selected,
                                child.list_add_on_selected,
                                'percent',
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            } else {
              if (parent.parent_item_selected) {

                let menuItem = vm.initMenuItem(
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                "",
                                "",
                                'percent',
                                "",
                                parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            }
          }
        break;

        case "require":
          // check if selected first or second
          for (let c in vm.item.condition_categories) {
            let category = vm.item.condition_categories[c]
            if (vm.item.first_selected.length > 0) {
              for (let first in vm.item.first_selected) {
                if (vm.item.second_selected.length > 0) {
                  for (let second in vm.item.second_selected) {
                    let menuItem = vm.initMenuItem(
                                        category.value,
                                        "",
                                        "",
                                        vm.item.first_selected[first],
                                        vm.item.second_selected[second],
                                        'require_category',
                                        category.sku,
                                        "",
                                        "")
                    vm.item.coupon_menus.push(menuItem)
                  }
                } else {
                  let menuItem = vm.initMenuItem(
                                  category.value,
                                  "",
                                  "",
                                  vm.item.first_selected[first],
                                  "",
                                  'require_category',
                                  category.sku,
                                  "",
                                  "")
                  vm.item.coupon_menus.push(menuItem)
                }
              }
            } else {
              if (vm.item.second_selected.length > 0) {
                for (let second in vm.item.second_selected) {
                  let menuItem = vm.initMenuItem(
                                  category.value,
                                  "",
                                  "",
                                  "",
                                  vm.item.second_selected[second],
                                  'require_category',
                                  category.sku,
                                  "",
                                  "")
                  vm.item.coupon_menus.push(menuItem)
                }
              } else {
                let menuItem = vm.initMenuItem(
                                  category.value,
                                  "",
                                  "",
                                  "",
                                  "",
                                  'require_category',
                                  category.sku,
                                  "",
                                  "")
                vm.item.coupon_menus.push(menuItem)
              }
            }
          }

          // menu items
          for (let f in menuItems) {
            let parent = menuItems[f]
            if (parent.list_child.length > 0) {
              for (let c in parent.list_child) {
                let child = parent.list_child[c]

                let menuItem = vm.initMenuItem(
                                  "",
                                  parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                  !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                  child.list_variant_selected,
                                  child.list_add_on_selected,
                                  type,
                                  "",
                                  parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                  !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            } else {
              if (parent.parent_item_selected) {
                let menuItem = vm.initMenuItem(
                                  "",
                                  parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                  !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
                                  "",
                                  "",
                                  type,
                                  "",
                                  parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
                                  !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
                vm.item.coupon_menus.push(menuItem)
              }
            }
          }
        break;

        default:
        break;
      }
    },
    convertDateTimeToUTC (datetime) {
      return this.$moment(datetime).utc()
    },
    convertUTCToClientDateTime (datetime) {
      return this.$moment.utc(datetime).local()
    },
    refactorMenuData (data){
      for (let i in data) {
        if (data[i]) {
          if (typeof data[i].require_menu_item !== 'undefined') {
            delete data[i].require_menu_item
          }
          if (typeof data[i].menu_item !== 'undefined') {
            delete data[i].menu_item
          }
        }
      }
    },
    saveCoupon () {
      vm.validateFreeItemCoupon();
      vm.$bus.$emit('loading', 'block')
      vm.isProcessing = true;
      let oldUrl = []
      let formData = new FormData()
      for (let i in vm.item.image) {
        if (vm.item.image[i] && vm.item.image[i].type) {
          formData.append(i, vm.item.image[i])
        }
        else{
          oldUrl[i] = vm.item.image[i]
        }
      }
      let config = {headers: {'Content-Type': 'multipart/form-data'}}

      //call an API to save imag
      vm.axios.coupon.uploadCouponImages(formData, config, function(response){
        vm.item.image={}
        if(response.data.status===true){
          vm.initialImage()

          for (let i in response.data.data.item) {
            vm.item.image[i] = response.data.data.item[i]
            vm.imageData[i] = response.data.data.item[i]
          }
          //get old url
          for (let i in oldUrl) {
            vm.item.image[i] = oldUrl[i]
            vm.imageData[i] = oldUrl[i]
          }
          // vm.imageData = vm.item.image
          vm.item.coupon_menus = []

          for (let i in vm.payment_methods) {
            let selected = vm.payment_methods[i].selected && vm.payment_methods[i].selected.length ? 1 : 0
            let method = {
              'label': vm.payment_methods[i].label,
              'method': vm.payment_methods[i].method,
              'value': selected,
              'display_name': vm.payment_methods[i].display_name,
              'description': vm.payment_methods[i].description,
              'image': vm.payment_methods[i].image,
              'selected': vm.payment_methods[i].selected
            }
            vm.item.payment_methods[i] = method
          }

          // Process menu items
          if(vm.item.coupon_type_id==1 && vm.item.discount_menu_items.length > 0){
            vm.processSaveCouponMenu(vm.item.discount_menu_items, 'free')
          }
          if(vm.item.circle_menu_item_selected){
            vm.processSaveCouponMenu(vm.item.circle_menu_item_selected, 'circle_discount')
          }
          if(vm.item.coupon_type_id==2 && (vm.item.discount_unit_items.length > 0
            || vm.item.discount_unit_categories && vm.item.discount_unit_categories.length > 0)){
            vm.processSaveCouponMenu(vm.item.discount_unit_items, 'unit')
          }
          if(vm.item.coupon_type_id==3 && (vm.item.discount_percent_items.length > 0
            || vm.item.discount_percent_categories && vm.item.discount_percent_categories.length > 0)){
            vm.processSaveCouponMenu(vm.item.discount_percent_items, 'percent')
          }
          if(vm.item.require_menu_items.length > 0
            || vm.item.condition_categories && vm.item.condition_categories.length > 0){
            vm.processSaveCouponMenu(vm.item.require_menu_items, 'require')
          }

          if(vm.item.exclude_items.require_menu_items.length > 0
            || vm.item.exclude_items.condition_categories && vm.item.exclude_items.condition_categories.length > 0){
            vm.processSaveExclusionMenu(vm.item.exclude_items.require_menu_items, 'exclude_item')
          }

          for (var hour in vm.item.timeHours) {
            if (hour < 7) {
              let date = vm.item.timeHours[hour].proper_date.toLowerCase().trim()
              vm.item[date] = vm.item.timeHours[7].value.indexOf(vm.item.timeHours[hour].proper_date) > -1 ? 1 : 0
            }
          }

          if (vm.item.coupon_type_id!=5) {
            vm.item.circle_discount_type=null
          }

          // vm.item.receipt_name = vm.item.skuData.receipt_name
          if (vm.item.skuData) {
            vm.item.sku = vm.item.skuData.text
          } else {
            vm.item.sku = null
          }

          vm.refactorMenuData(vm.item.discount_menu_items)
          vm.refactorMenuData(vm.item.discount_unit_items)
          vm.refactorMenuData(vm.item.discount_percent_items)
          vm.refactorMenuData(vm.item.require_menu_items)
          vm.refactorMenuData(vm.item.exclude_items.require_menu_items)

          vm.item.discount_percent_unit = vm.getDiscountPercentUnit(vm.couponContants.DISCOUNT_PERCENT_DECIMAL)
          vm.item.customize = vm.getCustomize()
          vm.item.customize['exclude_items'] = {
            exclude: vm.item.exclude_items.exclude,
            condition_categories: vm.item.exclude_items.condition_categories,
            coupon_menus: vm.item.exclude_items.coupon_menus
          }
          vm.item.customize['ala_carte_min_cart'] = vm.item.ala_carte_min_cart
          vm.item.customize['single_use_coupon_login'] = vm.item.single_use_coupon_login

          if (vm.id == 'create' || vm.id == undefined) {
            vm.axios.coupon.createCoupon(vm.item, function(response){
              vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
              vm.isProcessing = false
              vm.$router.push({name: 'coupon_list'})
            }, function(){
              vm.isProcessing = false
            });
          } else {
            vm.item.sequence = parseInt(vm.item.sequence)
            vm.axios.coupon.updateCoupon(vm.item, function(response){
              vm.item.validate_user_name.push(vm.item.single_user_name);
              vm.item.validate_user_url.push(vm.item.single_user_url);
              vm.item.single_user_name = '';
              vm.item.single_user_url = '';
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.isProcessing = false
            }, function(){
              vm.isProcessing = false
            });
          }
        }
        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    revertDateFormat (val) {
      let formatDate = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      return this.convertDateTimeToUTC(formatDate)
    },
    convertDateFormat (val) {
      //val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    convertDateTimeFormat (val) {
      //val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
    },
    removeSpecialDate (index) {
      let dates = []
      for (let i in this.item.special_dates) {
        if (i != index) {
          dates.push(this.item.special_dates[i])
        }
      }
      this.item.special_dates = dates
    },
    addSpecialDate () {
      this.item.special_dates.push({
        name: '',
        start_date: this.$moment().format('DD-MM-YYYY HH:mm:ss'),
        end_date: this.$moment().format('DD-MM-YYYY HH:mm:ss'),
      })
    },
    getAddonByMenuId(parent, variant_selected_sku){
      let langs = vm.languages
      let add_on=[]
      for (let l in langs)
      {
        add_on[langs[l]] = []
        var obj = _.find(parent, function (obj) { return obj.sku === variant_selected_sku });
        if(obj){
          for (let s in obj.second_layers) {
            let second = obj.second_layers[s]
            if (second['name'] != null && second['name'][langs[l]] != undefined && second['name'][langs[l]] != '') {
              add_on[langs[l]].push({
                  value: second['sku'],
                  text: second['name'][langs[l]]
              })
            } else {
              add_on[langs[l]].push({
                  value: second['sku'],
                  text: 'Invalid Name ('+second['sku']+')',
              })
            }
          }
        }
      }
      return add_on;
    },
    getVariantByMenuId(parent){
      let langs = vm.languages
      let variants=[]
      let add_on=[]

      for (let l in langs)
      {
        variants[langs[l]] = []
        add_on[langs[l]] = []

        for (let f in parent.first_layers)
        {
          let first = parent.first_layers[f]
          add_on[langs[l]][first['sku']] = []
          for (let s in first.second_layers) {
            let second = first.second_layers[s]
            if (second['name'] != null && second['name'][langs[l]] != undefined && second['name'][langs[l]] != '') {
              add_on[langs[l]][first['sku']].push({
                  value: second['sku'],
                  text: second['name'][langs[l]]
              })
            }
          }
          if (first['name'] != null && first['name'][langs[l]] != undefined && first['name'][langs[l]] != '') {
            variants[langs[l]].push({
                value: first['sku'],
                text: first['name'][langs[l]],
                addons:[],
                addon_selected:""
            })
          }
        }
      }

      //set add ons
      for (let l in langs) {
        for (let s in variants[langs[l]]) {
          variants[langs[l]][s].addons = add_on[langs[l]][variants[langs[l]][s].value]
        }
      }
      return variants;
    },
    // discount menu item
    addDiscountMenuItem()
    {
      vm.item.discount_menu_items.push({
        require_menu_item:vm.menus,
        parent_item_selected:"",
        list_child:[]
      })
      vm.validateFreeItemCoupon();
    },
    addDiscountMenuSizeCrust(parent)
    {
      if(!parent) return;
      parent.list_child.push({
        list_variant:vm.getVariantByMenuId(parent.parent_item_selected),
        list_variant_selected:"",
        list_add_on: [],
        list_add_on_selected:"",
        deleted:0,
        id:0
      })
      vm.validateFreeItemCoupon();
    },
    removeDiscountMenuSizeCrust(parent,index) {
      parent.list_child.splice(index, 1)
      vm.validateFreeItemCoupon();
    },
    removeDiscountMenuItem(index) {
      vm.item.discount_menu_items.splice(index, 1)
      vm.validateFreeItemCoupon();
    },
    discountMenuItemChange(p){
      p.list_child=[]
      vm.validateFreeItemCoupon();
    },
    discountMenuSizeCrustChange(parent, menuItem, lang){
      if(!parent ||!menuItem || !menuItem.list_variant) return
      menuItem.list_add_on[lang]=[]
      var addon = _.find(menuItem.list_variant[lang], function (obj)
      {
        return obj.value === menuItem.list_variant_selected;
      });
      if(!addon) return
      menuItem.list_add_on[lang]=addon.addons;
      vm.validateFreeItemCoupon();
    },
    // discount menu item
    updateMenuItemStatus () {
      this.menu_items_status = this.menu_items_status?false:true
    },
    updateRequireMenuItemStatus () {
      this.require_menu_items_status = this.require_menu_items_status?false:true
    },
    previewImage (event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.imageData[input.id] = e.target.result
        }
        let data = {}
        for (let i in this.images) {
          data[this.images[i]] = this.imageData[this.images[i]]
        }
        this.imageData = data
        reader.readAsDataURL(input.files[0])
        this.item.image[input.id] = input.files[0]
      }
    },
    getCouponTypies () {
      vm.axios.coupon.getCouponTypies(function(response){
        vm.coupontypies = []
        let langs = vm.languages
        for (let l in langs) {
          vm.coupontypies[langs[l]] = [{
              value: "",
              text: vm.$t('coupon.select_coupon_type', langs[l])
          }]
          for (let c in response.data.data.items) {
            let item = response.data.data.items[c]
            if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
              vm.coupontypies[langs[l]].push({
                  value: item['id'],
                  text: item['name'][langs[l]]
              })
            }
          }
        }
      })
    },
    getOrderTypes(){
      let langs = vm.languages
      for (let l in langs) {
        let lang = langs[l]
        vm.coupon_order_types[lang] = []
        vm.coupon_order_types[lang].push({
            value: "delivery",
            text: vm.$t('common.delivery', lang)
        })
        vm.coupon_order_types[lang].push({
            value: "takeaway",
            text: vm.$t('common.takeaway', lang)
        })
        vm.coupon_order_types[lang].push({
            value: "restaurant",
            text: vm.$t('common.restaurant', lang)
        })
        vm.coupon_order_types[lang].push({
            value: "all",
            text: vm.$t('common.all', lang)
        })
      }
    },
    getSaleChannels(){
      let langs = vm.languages
      for (let l in langs) {
        let lang = langs[l]
        vm.sale_channels[lang] = [
          {
            value: "web",
            text: vm.$t('common.web', lang)
          },
          {
            value: "ios",
            text: vm.$t('coupon.ios', lang)
          },
          {
            value: "android",
            text: vm.$t('coupon.android', lang)
          },
        ]
      }
    },
    getDeposition(lang, dispositions){
      let dispositionText = '';
      for (let disposition in dispositions) {
        dispositionText += vm.$t('coupon.'+dispositions[disposition], lang) + ', ';
      }
      return dispositionText.slice(0, -2);
    },
    processMenuItemsData (params) {
      vm.isLoadingMenu = true
      vm.axios.coupon.getListCouponMenu(params, function(response) {
        let data = response.data.data.items
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.menus[lang] = []
          vm.categories[lang] = []
          vm.custom_menus[lang] = []

          for (let g in data) {
              let items = []
              let group = data[g]
              for (let c in group.items) {
                let item = group.items[c]
                // Check deposition
                const disposition = vm.getDeposition(lang, item.disposition);
                let name = 'Invalid Name';
                if (item['name'] != null && item['name'][lang] != undefined && item['name'][lang] != '') {
                  name = item['name'][lang];
                }
                if (disposition.length > 0) {
                  let obj = {
                    value: item['uuid'],
                    text: item['sku'] + ' - ' + name + ' - ' + disposition,
                    is_combo: item['is_combo'],
                    sku: item['sku'],
                    first_layers: !item['is_combo'] ? item["first_layers"] : []
                  };
                  items.push(obj);
                  vm.custom_menus[lang][item['uuid']] = obj;
                }
              }
              vm.menus[lang].push({
                  group: group['category_name'][lang],
                  items: items
              })

              if (group['category_name'][lang]) {
                vm.categories[lang].push({
                    value: group['category_uuid'],
                    text: group['category_name'][lang],
                    sku: group['category_sku']
                })
              }
          }
        }
        vm.$forceUpdate('menus')
        vm.$forceUpdate('custom_menus')
        vm.$forceUpdate('categories')
        vm.isLoadingMenu = false
      })
    },
    getAllMenuItems() {
      let params = '?base_category=1'
      vm.processMenuItemsData(params)
    },
    // getOnlyDiscountMenuItems(){
    //   let params = '?base_category=1'
    //   vm.processMenuItemsData(params)
    // },
    getOutlets(){
      vm.isLoadingOutlet = true
      let params = 'disposition=all&language=all'
      vm.axios.coupon.getOutlets(params, function(response){
        let data=response.data.data.items
        if(!data) return
        let langs = vm.languages
        for (let l in langs) {
          vm.outlets[langs[l]] = []
          for (let c in data) {
            let item = data[c]
            if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
              vm.outlets[langs[l]].push({
                  value: item['code'],
                  text: item['code']+ ' - ' +item['name'][langs[l]]
              })
            }
          }
        }
        vm.$forceUpdate('outlets')
        vm.isLoadingOutlet = false
      })
    },
    getOutletGroups(){
      vm.isLoadingOutletGroup = true
      let params = 'fields=uuid,name&active=1&limit=9999999'
      vm.axios.coupon.getListOutletGroup(params, function(response) {
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.outletGroups[lang] = []
          for (let c in response.data.data.items) {
              let item = response.data.data.items[c]
              if (item['name'] != null && item['name'][lang] != undefined && item['name'][lang] != '') {
                  vm.outletGroups[lang].push({
                      value:  item['uuid'],
                      text:   item['name'][lang],
                  })
              }
          }
        }
        vm.$forceUpdate('outletGroups')
        vm.isLoadingOutletGroup = false
      })
    },
    loadCouponMenusData (menus, type) {
      let freeMenuItems=menus.filter(function(item){
        return item.type==type
      })
      let customFreeMenuitems = []
      if (freeMenuItems.length > 0) {
        //group by parent ID
        for (let i in freeMenuItems) {
          let itemID = freeMenuItems[i].combo_uuid ? freeMenuItems[i].combo_uuid : freeMenuItems[i].single_uuid
          if (!customFreeMenuitems[itemID]) {
            customFreeMenuitems[itemID] = []
          }

          customFreeMenuitems[itemID].push({
            'first_layer_sku': freeMenuItems[i].first_layer_sku,
            'second_layer_sku': freeMenuItems[i].second_layer_sku
          })
        }

        //fill data into vue item
        for (let i in customFreeMenuitems) {
          let parent = vm.custom_menus[vm.$session.get('lang')][i]
          if (parent !== undefined) {
            let itemSelected = {
                value: i,
                text: parent.text,
                first_layers:parent.first_layers,
                is_combo: parent.is_combo,
                sku: parent.sku
            }
            let list_child = []
            for (let j = 0; j < customFreeMenuitems[i].length; j++) {
              if (customFreeMenuitems[i][j].first_layer_sku || customFreeMenuitems[i][j].second_layer_sku) {
                list_child.push({
                  list_variant:vm.getVariantByMenuId(parent),
                  list_variant_selected:customFreeMenuitems[i][j].first_layer_sku,
                  list_add_on:vm.getAddonByMenuId(parent.first_layers, customFreeMenuitems[i][j].first_layer_sku),
                  list_add_on_selected:customFreeMenuitems[i][j].second_layer_sku,
                  deleted:0,
                  id:0
                })
              }
            }

            switch (type) {
              case "free":
                vm.item.discount_menu_items.push({
                  require_menu_item:vm.menus,
                  parent_item_selected:itemSelected,
                  list_child:list_child
                })
              break;

              case "unit":
                vm.item.discount_unit_items.push({
                  require_menu_item:vm.menus,
                  parent_item_selected:itemSelected,
                  list_child:list_child
                })
              break;

              case "percent":
                vm.item.discount_percent_items.push({
                  require_menu_item:vm.menus,
                  parent_item_selected:itemSelected,
                  list_child:list_child
                })
              break;

              case "circle_discount":
                vm.item.circle_menu_item_selected = {
                  value: itemSelected.value,
                  text: itemSelected.text,
                  first_layers:itemSelected.first_layers,
                  is_combo: itemSelected.is_combo,
                  list_child:list_child,
                  sku: itemSelected.sku
                }
              break;

              case "exclude_item":
                vm.item.exclude_items.require_menu_items.push({
                  parent_item_selected:itemSelected,
                  list_child:list_child
                })
              break;

              default: // require
                vm.item.require_menu_items.push({
                  require_menu_item:vm.menus,
                  parent_item_selected:itemSelected,
                  list_child:list_child
                })
              break;
            }
          }
        }
      }
    },
    mergePaymentMethods (originalMethods, editedMethods, autoApply) {
      if (editedMethods.length > 0) {
        const mergedMethods = [];
        for (const originalMethod of originalMethods) {
          const editedMethod = vm._.find(editedMethods, {method: originalMethod.method});
          if (vm._.isEmpty(editedMethod)) {
            if (!autoApply) {
              originalMethod.selected = null;
              originalMethod.value = 0;
            }
            mergedMethods.push(originalMethod);
            continue;
          }
          editedMethod.display_name = originalMethod.display_name;
          editedMethod.description = originalMethod.description;
          editedMethod.image = originalMethod.image;
          mergedMethods.push(editedMethod);
        }
        return mergedMethods;
      }
      return originalMethods;
    },
    processSelectedDate(selected){
      let itemTimeHours = {
        0: {'date': 'common.mon', 'proper_date': 'Mon'},
        1: {'date': 'common.tue', 'proper_date': 'Tue'},
        2: {'date': 'common.wed', 'proper_date': 'Wed'},
        3: {'date': 'common.thu', 'proper_date': 'Thu'},
        4: {'date': 'common.fri', 'proper_date': 'Fri'},
        5: {'date': 'common.sat', 'proper_date': 'Sat'},
        6: {'date': 'common.sun', 'proper_date': 'Sun'},
        7: {'date': 'selectedTimeHours', 'value': selected}
      }
      vm.item.timeHours = itemTimeHours
    },
    mappingCouponData(coupon)
    {
      vm.item.coupon_id = coupon.id
      vm.payment_methods = vm.mergePaymentMethods(vm.payment_methods, coupon.payment_methods, coupon.auto_apply)

      vm.item.name=coupon.name
      vm.item.min_discount_quantity=coupon.min_discount_quantity
      vm.item.max_discount_quantity=coupon.max_discount_quantity
      // vm.item.crm_url=coupon.crm_url
      // vm.item.applicable_active_date_for_user=coupon.applicable_active_date_for_user
      vm.item.marketing_name=coupon.marketing_name
      vm.item.check_is_member=coupon.check_is_member
      vm.item.code=coupon.code
      vm.item.outlet_group_uuid=coupon.outlet_group_uuid
      vm.item.order_type=coupon.order_type
      vm.item.content=coupon.content
      vm.item.coupon_type_id=coupon.coupon_type_id
      vm.item.image = coupon.image
      vm.item.active=coupon.active
      vm.item.is_show=coupon.is_show
      vm.item.multiple_use=coupon.multiple_use
      vm.item.sale_channel=coupon.sale_channel
      vm.item.validate_user_name=coupon.validate_user_name || []
      vm.item.validate_store_name=coupon.validate_store_name
      vm.item.validate_user_url=coupon.validate_user_url || []
      vm.item.validate_store_url=coupon.validate_store_url
      vm.item.condition_categories=coupon.condition_categories
      vm.item.discount_unit_categories=coupon.discount_unit_categories
      vm.item.discount_percent_categories=coupon.discount_percent_categories
      vm.item.exclude_outlet_list=coupon.exclude_outlet_list
      vm.item.is_accept_online_order=coupon.is_accept_online_order
      vm.item.applicable_items=coupon.applicable_items
      vm.item.auto_apply=coupon.auto_apply
      vm.item.cover_all_menu=coupon.cover_all_menu
      vm.item.future_advance_order_only=coupon.future_advance_order_only
      vm.item.private_use=coupon.private_use
      vm.item.sku= coupon.sku
      vm.item.skuData={'text': coupon.sku, 'value': coupon.sku, 'receipt_name': coupon.receipt_name}
      vm.item.receipt_name=coupon.receipt_name
      vm.item.hut_day=coupon.hut_day
      vm.item.lunch_time=coupon.lunch_time
      vm.item.mon=coupon.mon
      vm.item.tue=coupon.tue
      vm.item.wed=coupon.wed
      vm.item.thu=coupon.thu
      vm.item.fri=coupon.fri
      vm.item.sat=coupon.sat
      vm.item.sun=coupon.sun
      vm.item.purchase_required=coupon.purchase_required?coupon.purchase_required:'all'
      vm.item.first_selected=coupon.first_selected
      vm.item.second_selected=coupon.second_selected
      vm.item.circle_discount_type=coupon.circle_discount_type?coupon.circle_discount_type:'unit'
      vm.item.toppings=coupon.toppings
      vm.item.sequence=coupon.sequence
      vm.item.can_use_direct=coupon.can_use_direct
      vm.item.auto_assign=coupon.auto_assign
      vm.item.is_senior_citizen=coupon.is_senior_citizen
      vm.item.valid_for=coupon.valid_for
      vm.validForCoupon=coupon.valid_for ? coupon.valid_for : ''
      vm.item.by_pass_min_cart=coupon.by_pass_min_cart
      vm.isCanSyncCoupon = vm.id && vm.id != 'create' && vm.isSyncCouponPermision

      vm.item.active_start_date=vm.convertDateFormat(coupon.active_from)
      vm.item.active_end_date=vm.convertDateFormat(coupon.active_to)
      vm.item.apply_start_date=vm.convertDateFormat(coupon.apply_from)
      vm.item.apply_end_date=vm.convertDateFormat(coupon.apply_to)

      for (let i in vm.images) {
        vm.imageData[vm.images[i]] = coupon.image[vm.images[i]] != null ? coupon.image[vm.images[i]] : ''
      }

      vm.item.discount_percent_unit=parseFloat(coupon.discount_percent_unit)
      vm.item.discount_each_amount=parseFloat(coupon.discount_each_amount)
      vm.item.number_of_coupon=parseInt(coupon.max_number_of_coupon)
      vm.item.max_email_click_of_user=parseInt(coupon.max_email_click_of_user)
      vm.item.max_coupon_of_user=parseInt(coupon.max_coupon_of_user)
      vm.item.min_card=parseFloat(coupon.min_card)
      vm.item.discount_limit=parseFloat(vm._.get(coupon, 'customize.discount_limit', 0) || 0),
      vm.item.sc_vat=parseFloat(vm._.get(coupon, 'customize.sc_vat', 0) || 0)
      vm.item.ala_carte_min_cart=(vm._.get(coupon, 'customize.ala_carte_min_cart', 0) || 0)
      vm.item.single_use_coupon_login=vm._.get(coupon, 'customize.single_use_coupon_login', 0)

      vm.item.exclude_items.exclude = vm._.get(coupon, 'customize.exclude_items.exclude', 'all')
      vm.item.exclude_items.condition_categories = vm.convertObjectToArray(vm._.get(coupon, 'customize.exclude_items.condition_categories', null), '')
      vm.item.exclude_items.coupon_menus = vm.convertObjectToArray(vm._.get(coupon, 'customize.exclude_items.coupon_menus', null), [])

      //load exception dates
      for (let i in coupon.exception_dates) {
        vm.item.special_dates.push({
          start_date:vm.convertDateTimeFormat(coupon.exception_dates[i].start_date),
          end_date:vm.convertDateTimeFormat(coupon.exception_dates[i].end_date),
          name:coupon.exception_dates[i].name,
          coupon_id:coupon.exception_dates[i].coupon_id,
        })
      }
      //Process selected date
      let selected = []
      if (coupon.mon) {
        selected.push('Mon')
      }
      if (coupon.tue) {
        selected.push('Tue')
      }
      if (coupon.wed) {
        selected.push('Wed')
      }
      if (coupon.thu) {
        selected.push('Thu')
      }
      if (coupon.fri) {
        selected.push('Fri')
      }
      if (coupon.sat) {
        selected.push('Sat')
      }
      if (coupon.sun) {
        selected.push('Sun')
      }
      vm.processSelectedDate(selected)

      // Updated menu data for coupon detail
      if (vm.coupon_menus.length > 0) {
        vm.loadCouponMenusData(vm.coupon_menus, 'free')
        vm.loadCouponMenusData(vm.coupon_menus, 'unit')
        vm.loadCouponMenusData(vm.coupon_menus, 'percent')
        vm.loadCouponMenusData(vm.coupon_menus, 'require')
        vm.loadCouponMenusData(vm.coupon_menus, 'circle_discount')
      }

      // Updated menu data for exclude item
      if (vm.item.exclude_items.coupon_menus.length > 0) {
        vm.loadCouponMenusData(vm.item.exclude_items.coupon_menus, 'exclude_item')
      }

      // Check coupon form is valid
      vm.validateFreeItemCoupon();
    },
    getCouponDetail()
    {
      vm.isLoadingCoupon = true
      if(!vm.id) return

      //get coupon detail
      vm.axios.coupon.getCouponDetail(vm.id, function(response){
        let coupon=response.data.data.item
        vm.coupon_menus=coupon.menus
        vm.mappingCouponData(coupon)

        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    uploadStores (event) {
      let input = event.target
      vm.$bus.$emit('loading', 'block')
      if (input.files && input.files[0]) {
        if (!CSV_FILE_PATTERN.test(input.files[0].name)) {
          vm.$toastr.error(vm.$t('message.upload_csv_fail_wrong_format'), vm.$t('message.error'), {})
          return
        }

        let formData = new FormData();
        formData.append('file', input.files[0]);
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        //call an API to save csv file
        vm.axios.coupon.validateOutletList(formData, config, function(response){
          if (response.data.data.item.status != VALIDATION_ALL_FAILED) {
            vm.item.upload_store_url = response.data.data.item.name
            let name = response.data.data.item.name.split('/')
            vm.item.validate_store_name = name[name.length-1]
            vm.item.validate_store_url = response.data.data.item.file

            if (response.data.data.item.status == VALIDATION_SUCCESS) {
              vm.$toastr.success(vm.$t('message.upload_csv_success', vm.$session.get('lang')), vm.$t('message.success'), {})
            } else {
              vm.$toastr.success(vm.$t('message.upload_csv_success', vm.$session.get('lang')), vm.$t('message.success'), {})
            }
          } else {
            vm.$toastr.error(vm.$t('message.upload_csv_failed', vm.$session.get('lang')), vm.$t('message.error'), {})
          }
          vm.$bus.$emit('loading', 'none')
        }, function(error){
          vm.$bus.$emit('loading', 'none')
        })
      }
    },
    uploadUsers (event) {
      let input = event.target
      vm.$bus.$emit('loading', 'block')
      if (input.files && input.files[0]) {
        if (!CSV_FILE_PATTERN.test(input.files[0].name)) {
          vm.$toastr.error(vm.$t('message.upload_csv_fail_wrong_format'), vm.$t('message.error'), {})
          return;
        }

        let formData = new FormData();
        formData.append('data', input.files[0]);
        let config = {headers: {'Content-Type': 'multipart/form-data'}}
        //call an API to save csv file
        vm.axios.coupon.validateUserList(formData, config, function(response){
          if (response.data.data.item.status != VALIDATION_ALL_FAILED) {
            // Coupon only import maximum 100 customer.
            if (response.data.data.item.total > 5000) {
              vm.$toastr.error(vm.$t('message.over_num_imported_customers_coupon', vm.$session.get('lang')), vm.$t('message.error'), {})
              vm.$bus.$emit('loading', 'none')
              return
            }

            vm.item.upload_user_url = response.data.data.item.name
            let name = response.data.data.item.name.split('/')
            vm.item.single_user_name = name[name.length-1]
            vm.item.single_user_url = response.data.data.item.file

            vm.$toastr.success(vm.$t('message.upload_csv_success', vm.$session.get('lang')), vm.$t('message.success'), {})
          } else {
            vm.$toastr.error(vm.$t('message.upload_csv_failed', vm.$session.get('lang')), vm.$t('message.error'), {})
          }
          vm.$bus.$emit('loading', 'none')
        }, function(error){
          vm.$bus.$emit('loading', 'none')
        })
      }
    },
    removeStoreUrl (name) {
      vm.$bus.$emit('loading', 'block')
      let params = 'type=store&name='+name
      vm.axios.coupon.removeCsvFile(params, function(response){
        vm.item.validate_store_name = ''
        vm.item.validate_store_url = ''
        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    removeUserUrl (name) {
      vm.$bus.$emit('loading', 'block')
      let params = 'type=user&name='+name
      vm.axios.coupon.removeCsvFile(params, function(response){
        vm.item.single_user_name = ''
        vm.item.single_user_url = ''
        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    getExampleURL () {
      const clientId = vm._.get(vm.$store.getters.config.base, 'id', null) || null
      vm.axios.coupon.getExampleFile(function(response){
        vm.store_url = response.data.data.item.store
        // ClientId of India is 125
        vm.user_url = clientId == 125 ? response.data.data.item.in_user : response.data.data.item.user
      })
    },
    getPurchseRequiredData(){
      let langs = vm.languages
      for (let l in langs) {
        let lang = langs[l]
        vm.purchase_required_data[lang] = []
        vm.purchase_required_data[lang].push({
            value: "all",
            text: vm.$t('coupon.select', lang)
        })
        vm.purchase_required_data[lang].push({
            value: "category",
            text: vm.$t('coupon.category', lang)
        })
        vm.purchase_required_data[lang].push({
            value: "menu",
            text: vm.$t('coupon.menu', lang)
        })
      }
    },
    getExcludeItemData(){
      vm.exclude_item_data = vm.purchase_required_data
    },
    getCircleDiscountData(){
      let langs = vm.languages
      for (let l in langs) {
        let lang = langs[l]
        vm.circle_discount_type_data[lang] = []
        vm.circle_discount_type_data[lang].push({
            value: "unit",
            text: vm.$t('coupon.unit', lang)
        })
        vm.circle_discount_type_data[lang].push({
            value: "free_item",
            text: vm.$t('coupon.free_item', lang)
        })
      }
    },
    getFirstLayer () {
      vm.axios.menu.getFirstLayer(function(response){
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.firstLayerData[lang] = []
          for (let i in response.data.data.items) {
            let item = {}
            item['text'] = response.data.data.items[i].name[lang]
            item['value'] = response.data.data.items[i].sku
            vm.firstLayerData[lang].push(item)
          }
        }
      })
    },
    getSecondLayer () {
      vm.axios.menu.getSecondLayer(function(response){
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.secondLayerData[lang] = []
          for (let i in response.data.data.items) {
            let item = {}
            item['text'] = response.data.data.items[i].name[lang]
            item['value'] = response.data.data.items[i].sku
            vm.secondLayerData[lang].push(item)
          }
        }
      })
    },
    getPaymentMethods (changeLang = false) {
      vm.axios.coupon.getPaymentMethods('', function(response){
        const paymentMethods = response.data.data.items
        for (let i in paymentMethods) {
          if (changeLang) {
            const paymentIdx = vm._.findIndex(vm.payment_methods, { method: paymentMethods[i]['code'] })
            const newLangPayment = vm._.cloneDeep(vm.payment_methods[paymentIdx])
            newLangPayment.display_name = vm._.get(paymentMethods[i], 'display_name', '')
            newLangPayment.description = vm._.get(paymentMethods[i], 'description', '')
            vm.payment_methods.splice(paymentIdx, 1, newLangPayment)
          } else {
            let item = {}
            item['label'] = paymentMethods[i].code
            item['method'] = paymentMethods[i].code
            item['value'] = 1
            item['display_name'] = paymentMethods[i].display_name
            item['description'] = paymentMethods[i].description
            item['image'] = paymentMethods[i].image_url
            item['selected'] = paymentMethods[i].code
            vm.payment_methods.push(item)
          }
        }
        vm.original_payment_methods = vm._.cloneDeep(vm.payment_methods)
      })
    },
    getToppings () {
      let params = '?types=0,2';
      vm.axios.coupon.getToppings(params, function(response){
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.toppingsData[lang] = []
          for (let i in response.data.data.items) {
            let item = {}
            item['text'] = response.data.data.items[i].name[lang]
            item['value'] = response.data.data.items[i].id
            vm.toppingsData[lang].push(item)
          }
        }

        vm.$forceUpdate('toppingsData')
      })
    },
    getCouponMaster () {
      let params = '';
      vm.isLoadingCouponMaster = true
      vm.axios.coupon.getCouponMaster(params, function(response){
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.couponMasterData[lang] = []
          for (let i in response.data.data.items) {
            let item = {}
            item['text'] = response.data.data.items[i].code
            item['value'] = response.data.data.items[i].code
            item['receipt_name'] = response.data.data.items[i].receipt_name
            vm.couponMasterData[lang].push(item)
          }
        }

        vm.$forceUpdate('couponMasterData')
        vm.isLoadingCouponMaster = false
        vm.$bus.$emit('loading', 'none')
      })
    },
    handleChangeAutoApply() {
      if(vm.item.auto_apply == 1) {
        vm.payment_methods = this._.cloneDeep(vm.original_payment_methods);
      }
    },
    needToAddCrustNSize(item= {}) {
      const { parent_item_selected = {}, circle_menu_item_selected = {} } = item;
      const itemSelected = vm.item.circle_discount_type === 'free_item' ? circle_menu_item_selected : parent_item_selected;
      if (vm.isEmpty(itemSelected)) return false;
      return !itemSelected.is_combo && itemSelected.first_layers && itemSelected.first_layers.length > 0;
    },
    invalidCrustNSizeItem(item = {}) {
      if (vm.item.circle_discount_type === 'free_item') {
        if (vm.isEmpty(item) || !vm.needToAddCrustNSize(vm.item)) return false;
      } else {
        if (vm.isEmpty(item.parent_item_selected) || !vm.needToAddCrustNSize(item)) return false;
      }
      const { list_child = [] } = item;
      if (vm.isEmpty(list_child)) return true;
      for (const child of list_child) {
        if (child.list_variant_selected && (child.list_add_on_selected || vm.isEmptyItemByLangArray(child.list_add_on))) return false;
      }
      return true;
    },
    validateFreeItemCoupon() {
      const { item = {} } = vm;
      if (item.coupon_type_id !== 1 && item.coupon_type_id !== 5) {
        vm.validFreeItemCouponForm = true;
        return;
      };
      if (item.coupon_type_id === 5 && item.circle_discount_type !== 'free_item') {
        vm.validFreeItemCouponForm = true;
        return;
      }
      if (vm.isEmptyFreeItem(item)) {
        vm.validFreeItemCouponForm = false;
        return;
      }
      if (item.coupon_type_id === 1) {
        for (const dMenuItem of item.discount_menu_items) {
          if (vm.invalidCrustNSizeItem(dMenuItem)) {
            vm.validFreeItemCouponForm = false;
            return;
          }
        }
      } else if (item.coupon_type_id === 5 && item.circle_discount_type === 'free_item') {
        if (vm.invalidCrustNSizeItem(item.circle_menu_item_selected)) {
          vm.validFreeItemCouponForm = false;
          return;
        }
      }

      vm.validFreeItemCouponForm = true;
    },
    isEmptyFreeItem(item) {
      const {
        discount_menu_items = [], circle_menu_item_selected = {},
        coupon_type_id, circle_discount_type
      } = item;
      if (coupon_type_id === 1) {
        if (vm.isEmpty(discount_menu_items)) return true;

        for (const menuItem of discount_menu_items) {
          if (!vm.isEmpty(menuItem.parent_item_selected)) return false;
        }
        return true;
      } else if (coupon_type_id === 5 && circle_discount_type === 'free_item') {
        if (vm.isEmpty(circle_menu_item_selected)) return true;
      }
      return false;
    },
    invalidRequireItemDiscount(item) {
      const discountItems = item.coupon_type_id === 2 ? item.discount_unit_items : item.discount_percent_items
      const discountCategories = item.coupon_type_id === 2 ? item.discount_unit_categories : item.discount_percent_categories
      return [2, 3].includes(item.coupon_type_id) && item.applicable_items==1 && this.isEmpty(discountCategories) && (this.isEmpty(discountItems) || this.isEmpty(this._.get(discountItems[0], 'parent_item_selected')))
    },
    validateApplicableItemsDiscount() {
      const { item = {} } = vm;
      const discountCategories = item.coupon_type_id === 2 ? item.discount_unit_categories : item.discount_percent_categories
      if (![2, 3].includes(item.coupon_type_id) || item.applicable_items!=1 || !this.isEmpty(discountCategories)) {
        vm.validApplicableItemsDiscount = true;
        return;
      }
      const discountItems = item.coupon_type_id === 2 ? item.discount_unit_items : item.discount_percent_items
      if (this.isEmpty(discountItems)) {
        vm.validApplicableItemsDiscount = false;
        return;
      }
      for (const dMenuItem of discountItems) {
        if (vm.invalidCrustNSizeItem(dMenuItem)) {
          vm.validApplicableItemsDiscount = false;
          return;
        }
      }
      vm.validApplicableItemsDiscount = true;
    },
    isSupportClient () {
      const clientId = localStorage.getItem('clientID')
      const supportClients = [
        vm.client_uuid.jp,
        vm.client_uuid.nz,
        vm.client_uuid.sg,
        vm.client_uuid.ph,
        vm.client_uuid.kw,
        vm.client_uuid.bz,
        vm.client_uuid.pe,
        vm.client_uuid.pr,
        vm.client_uuid.mx,
        vm.client_uuid.my
      ]

      return supportClients.includes(clientId)
    },
    isPhilippines () {
      const clientId = localStorage.getItem('clientID')
      return clientId === vm.client_uuid.ph
    },
    formatValidFor (e) {
      const num = e.target.value.replace(FILTER_NUMBER, '')
      e.target.value = num.length > 0 && num > 0 ? num : ''
      vm.item.valid_for = num.length > 0 && num > 0 ? parseInt(num) : 0
    },
    percentFormatter (val, n=2) {
      n = n && n > 1 ? n : 2;
      return (parseFloat(parseInt(parseFloat(val) * Math.pow(10, n))) / parseFloat(Math.pow(10, n)))
    },
    getDiscountPercentUnit (n=2) {
      if (vm.couponTypes.DISCOUNT_PERCENT == vm.item.coupon_type_id) {
         return vm.percentFormatter(vm.item.discount_percent_unit, n)
      }
      return vm.item.discount_percent_unit
    },
    getCustomize (n=2) {
      vm.item.sc_vat = vm.percentFormatter(vm.item.sc_vat, n)
      vm.item.discount_limit = parseFloat(vm.item.discount_limit)

      return {
        sc_vat: vm.item.sc_vat,
        discount_limit: vm.item.discount_limit
      }
    },
    checkCitizenCoupon () {
      return vm.item.coupon_type_id===3 && vm.item.is_senior_citizen
    },
    convertObjectToArray(val, defaultVal) {
      if (val instanceof Object && !_.isEmpty(val)) {
        return Object.values(val)
      }
      return defaultVal
    },
    processSaveExclusionMenu(menuItems, type) {
      vm.item.exclude_items.coupon_menus = []
      // check if selected first or second
      for (let c in vm.item.exclude_items.condition_categories) {
        let category = vm.item.exclude_items.condition_categories[c]
        if (vm.item.exclude_items.first_selected.length > 0) {
          for (let first in vm.item.exclude_items.first_selected) {
            if (vm.item.exclude_items.second_selected.length > 0) {
              for (let second in vm.item.exclude_items.second_selected) {
                let menuItem = vm.initMenuItem(
                  category.value,
                  "",
                  "",
                  vm.item.exclude_items.first_selected[first],
                  vm.item.exclude_items.second_selected[second],
                  type,
                  category.sku,
                  "",
                  "")
                vm.item.exclude_items.coupon_menus.push(menuItem)
              }
            } else {
              let menuItem = vm.initMenuItem(
                category.value,
                "",
                "",
                vm.item.exclude_items.first_selected[first],
                "",
                type,
                category.sku,
                "",
                "")
              vm.item.exclude_items.coupon_menus.push(menuItem)
            }
          }
        } else {
          if (vm.item.exclude_items.second_selected.length > 0) {
            for (let second in vm.item.exclude_items.second_selected) {
              let menuItem = vm.initMenuItem(
                category.value,
                "",
                "",
                "",
                vm.item.exclude_items.second_selected[second],
                type,
                category.sku,
                "",
                "")
              vm.item.exclude_items.coupon_menus.push(menuItem)
            }
          } else {
            let menuItem = vm.initMenuItem(
              category.value,
              "",
              "",
              "",
              "",
              type,
              category.sku,
              "",
              "")
            vm.item.exclude_items.coupon_menus.push(menuItem)
          }
        }
      }

      // menu items
      for (let f in menuItems) {
        let parent = menuItems[f]
        if (parent.list_child.length > 0) {
          for (let c in parent.list_child) {
            let child = parent.list_child[c]

            let menuItem = vm.initMenuItem(
              "",
              parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
              !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
              child.list_variant_selected,
              child.list_add_on_selected,
              type,
              "",
              parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
              !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
            vm.item.exclude_items.coupon_menus.push(menuItem)
          }
        } else {
          if (parent.parent_item_selected) {
            let menuItem = vm.initMenuItem(
              "",
              parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
              !parent.parent_item_selected.is_combo ? parent.parent_item_selected.value : "",
              "",
              "",
              type,
              "",
              parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "",
              !parent.parent_item_selected.is_combo ? parent.parent_item_selected.sku : "")
            vm.item.exclude_items.coupon_menus.push(menuItem)
          }
        }
      }
    },
    isCanSync () {
      return vm.sync_coupon.marketing_name || vm.sync_coupon.description || vm.sync_coupon.active_period || vm.sync_coupon.applicable_period
    },
    syncCoupon () {
      vm.$bus.$emit('loading', 'block')
      vm.isProcessing = true;
      vm.axios.coupon.syncCoupon(vm.id, vm.sync_coupon, (response) => {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.isProcessing = false
        vm.$bus.$emit('loading', 'none')
      }, () => {
        vm.isProcessing = false
        vm.$bus.$emit('loading', 'none')
      });
      vm.sync_coupon = {
        marketing_name: false,
        description: false,
        active_period: false,
        applicable_period: false
      }
    },
    checkPermission (modules, endPoint) {
      return modules.indexOf(endPoint) > -1
    },
    notifySingleCouponLoginChange() {
      if (1 == vm.item.single_use_coupon_login) {
        vm.$toastr.warning(vm.$t('message.single_use_coupon_login'), vm.$t('message.information'), {})
      }
    },
  },
  created: function () {
    vm = this
    const config = vm.$session.get('config')
    const manualConfig = vm._.get(config, 'manual_config', {}) || {}
    const modules = vm._.get(vm.userInfo, 'modules', [])
    vm.isSyncCouponPermision = vm.checkPermission(modules, SYNC_COUPON_API)

    vm.isSccJointly = manualConfig['PHI_scc_joint_use'] || false
    vm.$bus.$emit('loading', 'block')
    vm.getAllMenuItems()
    vm.getOutlets()
    vm.getOutletGroups()
    vm.getExampleURL()
    vm.getPurchseRequiredData()
    vm.getCircleDiscountData()
    vm.getPaymentMethods()
    vm.getToppings()
    vm.getCouponMaster()
    vm.getExcludeItemData()
  },
  // watch: {
  //   'item.cover_all_menu': {
  //     handler: function (val, oldVal) {
  //       if (val) {
  //         vm.getAllMenuItems()
  //       } else {
  //         vm.getOnlyDiscountMenuItems()
  //       }
  //     },
  //     deep: true
  //   },
  // },
  watch: {
    'item.applicable_items': function() {
      this.validateApplicableItemsDiscount()
    },
    'item.is_show': function(val) {
      if(!val) {
        vm.item.is_senior_citizen = 0
      }
    },
    'item.is_senior_citizen': function(val) {
      if(val) {
        vm.item.is_show = 1
      }
    },
    'item.active': (val) => {
      vm.isCanSyncCoupon = vm.id && vm.id != 'create' && vm.isSyncCouponPermision && val
    },
    'item.single_use_coupon_login': (val) => {
      if(val) {
        vm.item.can_use_direct = 1
        vm.item.private_use = 1
        vm.item.auto_assign = 0
        vm.item.auto_apply = 0
      }
    },
    'item.auto_assign': (val) => {
      if(val) {
        vm.notifySingleCouponLoginChange()
        vm.item.single_use_coupon_login = 0
      }
    },
    'item.private_use': (val) => {
      if(!val) {
        vm.notifySingleCouponLoginChange()
        vm.item.single_use_coupon_login = 0
      }
    },
    'item.can_use_direct': (val) => {
      if(!val) {
        vm.notifySingleCouponLoginChange()
        vm.item.single_use_coupon_login = 0
      }
    },
    'item.auto_apply': (val) => {
      if(val) {
        vm.notifySingleCouponLoginChange()
        vm.item.single_use_coupon_login = 0
      }
    },
  },
  updated: function () {
    if (vm.couponMasterData[vm.$session.get('lang')]!==undefined) {
      vm.customCouponMasterData = vm.couponMasterData[vm.$session.get('lang')]
    }
    if (vm.toppingsData[vm.$session.get('lang')]!==undefined) {
      vm.customToppingsData = vm.toppingsData[vm.$session.get('lang')]
    }
    if (vm.secondLayerData[vm.$session.get('lang')]!==undefined) {
      vm.customSecondLayerData = vm.secondLayerData[vm.$session.get('lang')]
    }
    if (vm.firstLayerData[vm.$session.get('lang')]!==undefined) {
      vm.customFirstLayerData = vm.firstLayerData[vm.$session.get('lang')]
    }
    if (vm.menus[vm.$session.get('lang')]!==undefined) {
      vm.menusList = vm.menus[vm.$session.get('lang')]
    }
    if (vm.outletGroups[vm.$session.get('lang')]!==undefined) {
      vm.outletGroupsList = vm.outletGroups[vm.$session.get('lang')]
    }
    if (vm.outlets[vm.$session.get('lang')]!==undefined) {
      vm.outletsList = vm.outlets[vm.$session.get('lang')]
    }
    if (vm.categories[vm.$session.get('lang')]!==undefined) {
      vm.categoryList = vm.categories[vm.$session.get('lang')]
    }
    if (vm.id != 'create' && vm.id !== undefined
      && !vm.isLoadingMenu
      && !vm.isLoadingCouponMaster
      && !vm.isLoadingOutletGroup
      && !vm.isLoadingOutlet
      && !vm.isLoadingCoupon) {
      vm.item.uuid = vm.id
      vm.getCouponDetail()
    }
  },
  mounted: function(){
    vm.initialImage()
    vm.getCouponTypies()
    vm.getOrderTypes()
    vm.getSaleChannels()
    vm.getFirstLayer()
    vm.getSecondLayer()
    vm.processSelectedDate([])

    if (vm.id == 'create' || vm.id === undefined){
      vm.item.number_of_coupon = 999999999
      vm.item.cover_all_menu = 0

      // set selected date
      let selected = []
      selected.push('Mon')
      selected.push('Tue')
      selected.push('Wed')
      selected.push('Thu')
      selected.push('Fri')
      selected.push('Sat')
      selected.push('Sun')
      vm.processSelectedDate(selected)
    }
    const timeoutId = setTimeout(() => {
      this.$root.$on('changeLang', () => {
        vm.getPaymentMethods(true)
      })
      clearTimeout(timeoutId);
    }, 3000);
  }
}
</script>

<style>
  .coupon-form input,
  .coupon-form textarea,
  .coupon-form select,
  .coupon-form .multiselect__tags {
      border-radius: 4px !important;
  }

  .multiselect__tags{
      border-radius: 0 !important;
  }

  .is-invalid .multiselect__tags {
      border-color: #f86c6b;
  }

  .coupon-form .btn-secondary{
    border-radius: 3px;
  }

  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check .form-check-input:disabled ~ label {
    cursor: not-allowed;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

  .applicable-store label span{
    width: 48px;
  }

  .applicable-store select{
    margin-right: 20px;
  }

  .img-min-height {
    height: 200px;
  }

  /*.multiselect__tags{
    min-height: 35px !important;
    padding: 2px 15px 0px 10px !important;
  }

  .multiselect__select{
    height: 36px !important;
  }

  .multiselect__placeholder{
    margin-bottom: 5px !important;
    padding-top: 4px !important;
  }*/

  .multiselect__placeholder{
    margin-bottom: 6px !important;
  }

  .not_apply_date .mx-input-append {
    display: none!important;
  }
  /*.not_apply_date .mx-calendar {*/
  /*   width: 400px!important;*/
  /* }*/
  .not_apply_date .mx-calendar-header {
    width: 100%!important;
  }
  .not_apply_date .mx-calendar-content {
    width : 100%!important;
    height: 100%!important;
  }
  .not_apply_date .mx-time-list{
    height: 225px;
  }

  .senior-citizen {
    padding-left: 3px !important;
  }
</style>

<style scoped>
  #application_result_content .gray-background{
    border-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #application_result_content .gray-light-background{
    border-radius: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .payment-methods{
    padding: 0 !important;
  }

  .payment-methods .form-group{
    padding: 10px 15px 0 15px;
    margin-bottom: 5px;
  }

  .payment-methods .form-group:last-child{
    margin-bottom: 15px;
  }

  .payment-methods .form-check{
    margin-left: 15px;
  }

  .business-hours .form-check{
    padding-right: 15px;
  }

  .business-hours{
    display: inline-flex;
    vertical-align: middle;
  }

  .size-circle{
    margin-left: 5px;
  }

  .sl-discount-unit,
  .ipt-discount-unit{
    min-height: 40px;
  }

  .delete-csv{
    background: transparent;
    color: #0086FF;
    border: none;
    font-size: 20px;
  }

  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 3px;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/

  .applicable-store{
    display: inline-flex;
  }

  /*.applicable-store label{
    margin-right: 20px;
  }*/

  .applicable-store input{
    margin-top: 5px;
  }

  .switch-custom{
    max-width: 5.3%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .col-sm-2-custom{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
    display: inline-flex;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }

  .gray-background .form-control{
    /*padding: 8px;*/
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .remark .btn-danger{
    margin-top: 7px;
    background-color: #fff;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8;
  }

  .table-bordered .btn-danger{
    margin-top: 4px;
  }

  .gray-background .btn-danger{
    background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa,
  .gray-light-background .btn-danger .fa,
  .remark .btn-danger .fa,
  .table-bordered .btn-danger .fa{
    color: #0086FF;
    font-size: 20px;
  }

  .gray-background .col-sm-10,
  .gray-light-background .col-sm-10,
  .gray-light-background .col-sm-5{
    padding-left: 5px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-bottom10{
    margin-bottom: 10px;
  }

  .clear-both{
    margin-bottom: 15px;
  }

  .card{
    margin-bottom: 0;
  }

  .coupon-image{
    margin: 0;
    padding: 0;
    display: inline-flex;
  }

  .coupon-properties{
    display: -webkit-inline-box;
    position: relative;
    margin: 0;
    padding: 0;
  }

  .coupon-image img{
    width: 100%;
  }

  .coupon-properties legend{
    width: auto;
    resize: both;
  }

  .coupon-properties .check-is-member{
    max-width: 16%;
  }

  .preview-image {
    width: 100%;
  }

  .font-size-inherit {
    font-size: inherit;
  }

  .valid-for-combobox {
    width: 72px;
    float: left;
    margin-right: 12px;
    padding: 6px;
    border-radius: 0 !important;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/coupon/BaseForm.vue